/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'VIDEO SHORT SAYA',
    see_more: 'LIHAT LEBIH LANJUT',
    no_shorts_found: 'Tiada Shorts ditemui',
    shorts: 'Shorts',
    general_information: 'Maklumat Am',
    gamification: 'Gamifikasi',
    click_to_select_files: 'Klik untuk memilih fail',
    selected_files: 'Fail Terpilih',
    uploaded: 'Dimuat naik',
    failed: 'Gagal',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Sistem akan menganalisis secara automatik dan memilih dokumen paling relevan dari perpustakaan organisasi anda berdasarkan keperluan kandungan.',
    select_from_library: ' Pilih dari perpustakaan',
    search_document: 'Cari dokumen...',
    selected: 'Terpilih',
    loading_documents: 'Memuatkan dokumen...',
    review_generated_content: 'Semak kandungan yang dijana',
    confirm_and_replace_content: 'Sahkan dan gantikan kandungan',
    the_generate_content_will_replace:
      'Kandungan yang dijana akan menggantikan teks sedia ada pada halaman terpilih. Jika anda tidak mahu menerapkan perubahan ini, anda boleh kembali ke langkah sebelumnya.',
    pages_to_be_updated: 'Halaman untuk dikemas kini',
    generated_revisions: 'Semakan yang dijana',
    lesson_preview: 'Pratonton Pelajaran',
    create_new_folder: 'Buat Folder Baru',
    rename_item: 'Tukar Nama Item',
    enter_folder_name: 'Masukkan nama folder:',
    enter_new_name: 'Masukkan nama baru:',
    folder_name: 'Nama Folder:',
    new_name: 'Nama Baru',
    move_items: 'Pindahkan Item',
    copy_items: 'Salin Item',
    move_here: 'Pindahkan ke sini',
    copy_here: 'Salin ke sini',
    select_destination_library_and_folder:
      'Pilih perpustakaan dan folder destinasi:',
    items_selected: 'Item Terpilih',
    version: 'Versi',
    modified_by: 'Diubah oleh',
    size: 'Saiz',
    restore: 'Pulihkan',
    are_you_sure_you_want_to_restore_this_version:
      'Adakah anda pasti ingin memulihkan versi ini?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Ini akan menggantikan versi semasa dengan yang dipilih.',
    restore_this_version: 'Pulihkan versi ini',
    restore_not_available: 'Pemulihan tidak tersedia',
    version_history: 'Sejarah Versi:',
    by_making_items_public:
      'Dengan menjadikan item awam, ia akan dapat dilihat oleh semua orang. Sila semak terma dan syarat sebelum meneruskan.',
    the_selected_items_will_be_copied:
      'Item terpilih akan disalin ke perpustakaan awam anda dan boleh dilihat oleh semua orang.',
    the_selected_items_will_be_copied_to_org:
      'Item terpilih akan disalin ke perpustakaan organisasi anda dan boleh dilihat oleh semua ahli organisasi.',
    the_selected_items_will_be_copied_to_your_private:
      'Item terpilih akan disalin ke perpustakaan peribadi anda dan hanya boleh dilihat oleh anda.',
    loading_organization: 'Memuatkan pengguna organisasi...',
    click_download_to_view: 'Klik muat turun untuk melihat',
    archive_file: 'Fail Arkib',
    no_preview_available: 'Tiada pratonton tersedia',
    audit_report: 'Laporan Audit',
    audit_type: 'Jenis Tindakan',
    i_agree_to_the_terms_and_conditions:
      'Saya bersetuju dengan terma dan syarat.',
    this_file_is_indexed_for_ai: 'Fail ini diindeks untuk AI.',
    file_is_not_indexed_for_ai: 'Fail tidak diindeks untuk AI.',
    no_users_found: 'Tiada pengguna ditemui',
    no_users_available: 'Tiada pengguna tersedia',
    add_people: 'Tambah orang',
    people: 'Orang',
    access_type: 'Jenis Akses',
    no_group_found: 'Tiada kumpulan ditemui',
    add_group: 'Tambah kumpulan',
    groups: 'Kumpulan',
    users_top: 'Pengguna',
    confirm_delete: 'Sahkan Padam',
    do_you_want_remove: 'Adakah anda pasti mahu membuang',
    form_this_documents_permissions: 'daripada kebenaran dokumen ini?',
    no_users_found_in_this_group: 'Tiada pengguna ditemui dalam kumpulan ini',
    add_selected_users: 'Tambah Pengguna Terpilih',
    choose_users_from_the_list: 'Pilih pengguna dari senarai',
    selected_users: 'Pengguna Terpilih',
    archived: 'Diarkibkan',
    request_approval: 'Minta Kelulusan',
    document_in_review: 'Dokumen dalam semakan',
    approve: 'Luluskan',
    reject: 'Tolak',
    comment: 'Komen:',
    enter_your_commit: 'Masukkan komen anda...',
    confirm_cancel: 'Sahkan Batal',
    upload_3d_zip: 'Muat Naik 3D Zip',
    delete_items: 'Padam Item',
    video_upload_request: 'Permintaan muat naik video',
    reject_video: 'Tolak Video',
    enter_rejection_reason: 'Masukkan sebab penolakan...',
    please_provide_a_reason_for_reejection_this_video:
      'Sila berikan sebab menolak video ini:',
    generate_trivia_with_ai: 'Hasilkan Trivia dengan AI',
    select_category: 'Pilih Kategori:',
    number_of_question: 'Bilangan Soalan',
    generated_questions: 'Soalan Dijana',
    this_will_clear_all_generate_question:
      'Ini akan mengosongkan semua soalan yang dijana. Teruskan?',
    sure_delete: 'Adakah anda pasti mahu memadam?',
    delete_this_question: 'Adakah anda pasti mahu memadam soalan ini?',
    loading_quiz: 'Memuatkan Kuiz...',
    creteing_file: 'Sedang membuat fail',
    opening_desktop_app: 'Membuka aplikasi desktop...',
    this_folder_is_empty: 'Folder ini kosong',
    select_a_competition: 'Pilih pertandingan...',
    activity_badges: 'Lencana Aktiviti',
    awarded_every_badges:
      'Diberikan setiap 4, 8, 16, 32, 64, 128, 256, 512 log masuk',
    learning_badges: 'Lencana Pembelajaran',
    awarded_every_courses:
      'Diberikan setiap 1, 4, 8, 16, 32, 64, 128 kursus selesai',
    test_badges: 'Lencana Ujian',
    awarded_every_passes_tests:
      'Diberikan setiap 2, 4, 8, 16, 32, 64, 128, 256 ujian lulus',
    assignment_badges: 'Lencana Tugasan',
    awarded_every_passed_assignments:
      'Diberikan setiap 1, 2, 4, 8, 16, 32, 64, 128 tugasan lulus',
    perfectionism_badges: 'Lencana Kesempurnaan',
    awarded_every_assignments_with_scrore:
      'Diberikan setiap 1, 2, 4, 8, 16, 32, 64, 128 ujian atau tugasan dengan skor 90%+',
    communication_badges: 'Lencana Komunikasi',
    awarded_every_topics_or_comments:
      'Diberikan setiap 2, 4, 8, 16, 32, 64, 128, 256 topik atau komen',
    certification_badges: 'Lencana Pensijilan',
    awarded_every_certificates:
      'Diberikan setiap 1, 2, 4, 8, 16, 32, 64, 128 sijil',
    level_name: 'Nama Tahap',
    delete_competition: 'Padam Pertandingan',
    this_week: 'Minggu Ini',
    this_year: 'Tahun Ini',
    make_organization: 'Jadikan Organisasi',
    no_results_found: 'Tiada hasil ditemui untuk',
    no_items_available: 'Tiada item tersedia',
    help_video: 'Video Bantuan',
    select_a_video_from_the_list: 'Pilih video dari senarai untuk mula belajar'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Lepaskan fail dan pilih lokasi untuk muat naik.',
    duplicate_lessoon: 'Pelajaran sudah ada dalam kursus.',
    skill_rule_title: 'Sila masukkan Tajuk Perjalanan Kemahiran',
    imageCreatorTitle: 'Pencipta Imej',
    isTranslated: 'Diterjemahkan',
    translationCourseDesc:
      'Terjemahan kursus ini mungkin mengambil masa beberapa minit. Terima kasih atas kesabaran anda!',
    translateCourseTip:
      'Cipta kursus terjemahan yang boleh anda ubah suai secara bebas daripada asalnya, termasuk semua pelajaran dan halaman.',
    translateModalBtn: 'Terjemah',
    translationSuccess: 'Kursus "<0/>" telah berjaya diterjemahkan!',
    translatingCourse: 'Menterjemah Kursus...',
    translateModalTitle: 'Terjemah Kursus',
    translateSelectLang: 'Pilih Bahasa',
    fileDeleteconfirm:
      'Adakah anda pasti mahu memadamkan fail ini? Tindakan ini tidak boleh diundurkan.',
    fileDeleteMessage: 'Fail berjaya dipadam.',
    fileDeleteFailedMessage: 'Gagal memadamkan fail!',
    fileDelete: 'Padam fail ini.',
    certificate_save_btn: 'Tambah Sijil ke ',
    maze_path_info: 'Tiada laluan tersedia untuk graf!',
    file_size_mb: 'Saiz fail mesti kurang daripada 25 MB!',
    reports: {
      products: 'Produk',
      users: 'Pengguna',
      ph_username: 'Cari pengguna mengikut nama pengguna',
      ph_id: 'Cari pengguna mengikut Nombor ID',
      ph_email: 'Cari pengguna mengikut emel'
    },
    select_upload_section_id: 'Fail seksyen diperlukan',
    tags_all: 'Semua',
    delete_file_confirm: 'Adakah anda pasti mahu memadam fail ini?',
    delete_file_title: 'Padam Fail',
    tooltip_publish: 'Terbitkan kursus pada pilihan yang dipilih',
    tooltip_save: 'Simpan kursus dengan kemas kini semasa',
    tooltip_next: 'Pergi ke tetapan kursus seterusnya',
    tooltip_finish: 'Lengkapkan dan simpan kemas kini semasa',
    stories_modal: {
      title_upload: 'Muat Naik Cerita',
      title_update: 'Kemas Kini Cerita',
      title_audio: 'Fail Cerita Audio',
      btn_upload: 'Muat Naik',
      btn_update: 'Kemas Kini',
      btn_close: 'Tutup',
      btn_cancel: 'Batal',
      lbl_cover: 'Gambar Kulit Cerita',
      rule_cover: 'Sila muat naik kulit cerita audio!',
      lbl_title: 'Tajuk Cerita Audio',
      rule_title: 'Sila masukkan tajuk cerita audio!',
      lbl_description: 'Penerangan Cerita Audio',
      rule_description: 'Sila masukkan penerangan cerita audio!',
      lbl_file: 'Muat naik fail Cerita Audio',
      rule_file: 'Sila muat naik fail cerita audio!',
      rule_file_type: 'Sila muat naik fail cerita audio yang sah!',
      lbl_select_file: 'Pilih Fail Cerita Audio',
      msg_valid_file: 'Sila pilih fail cerita audio yang sah!',
      msg_success: 'Fail cerita audio berjaya dimuat naik',
      msg_failed: 'Gagal menetapkan data media!',
      msg_error: 'Ralat semasa memuat naik fail!'
    },
    audio_modal: {
      title_upload: 'Muat Naik',
      title_update: 'Kemas Kini',
      title_audio: 'Fail Audio',
      btn_upload: 'Muat Naik',
      btn_update: 'Kemas Kini',
      btn_close: 'Tutup',
      btn_cancel: 'Batal',
      lbl_cover: 'Kulit Audio',
      rule_cover: 'Sila muat naik kulit audio!',
      lbl_title: 'Tajuk Audio',
      rule_title: 'Sila masukkan tajuk audio!',
      lbl_description: 'Penerangan Audio',
      rule_description: 'Sila masukkan penerangan audio!',
      lbl_file: 'Muat naik fail Audio',
      rule_file: 'Sila muat naik fail audio!',
      rule_file_type: 'Sila muat naik fail audio yang sah!',
      lbl_select_file: 'Pilih Fail Audio',
      msg_valid_file: 'Sila pilih fail audio yang sah!',
      msg_success: 'Fail audio berjaya dimuat naik',
      msg_failed: 'Gagal menetapkan data media!',
      msg_error: 'Ralat semasa memuat naik fail!'
    },
    info_episode: 'Gambar kulit untuk episod.',
    btn_delete_episode: 'Padam episod podcast ini.',
    btn_edit_marketplace: 'Edit Butiran Marketplace.',
    btn_save_marketplace: 'Simpan perubahan semasa.',
    btn_ai_podcast: 'Cipta episod podcast dengan AI.',
    btn_upload_podcast: 'Muat naik episod audio podcast anda.',
    attach_file:
      'Muat naik fail untuk berkongsi lebih banyak kandungan dengan audiens anda',
    fileDownload: 'Muat turun fail ini.',
    singleEpishode: 'Episod',
    podcast_music: 'podcast, muzik & cerita',
    publishHeader: 'Terbit Podcast, Muzik & Cerita',
    editHeader: 'Edit Podcast, Muzik & Cerita',
    createHeader: 'Cipta Podcast, Muzik & Cerita',
    marketplaceHeader: 'Butiran Marketplace Podcast, Muzik & Cerita',
    message_marketplace: 'Sila lengkapkan borang marketplace!',
    create_podcast_live: 'Podcast dan Muzik Langsung',
    create_podcast_custom: 'Podcast dan Muzik Tersuai',
    create_podcast_stories: 'Cerita',
    ai_Assisted_podcast_reation: 'Podcast dan Muzik dengan Bantuan AI',
    publishTitle: 'Terbit podcast, muzik & cerita untuk tontonan umum.',
    customButton: 'Cipta Tersuai',
    customTitle: 'Simpan perubahan yang dibuat pada podcast.',
    updateButton: 'Kemas Kini',
    createButton: 'Cipta',
    createNewButton: 'Cipta Baru',
    updateTitle: 'Kemas kini butiran podcast, muzik & cerita semasa.',
    createTitle: 'Cipta podcast, muzik & cerita baharu',
    createNewTitle:
      'Podcast, muzik & cerita baharu akan dicipta berdasarkan input semasa.',
    podcastTitle: 'Senarai Episod',
    podcastStoryTitle: 'Senarai Episod Cerita',
    podcastToolTipTitle: 'Senarai episod podcast',
    uploadAudio: 'Muat Naik',
    aiAudio: 'Audio AI',
    emptyPodcast: 'Belum ada rakaman podcast, muzik atau cerita.',
    emptyStoriesPodcast: 'Tiada cerita ditambah lagi.',
    emptyCreatePodcast:
      'Sila cipta podcast terlebih dahulu untuk menambah audio.',
    playPodcast: 'Mainkan podcast, muzik & cerita yang dipilih.',
    pausePodcast: 'Jeda podcast, muzik & cerita yang dipilih.',
    selectPodcast: 'Pilih podcast, muzik & cerita ini.',
    downloadPodcast: 'Muat turun audio ini.',
    uploadAudioFile: 'Muat naik audio baharu dan gantikan audio semasa.',
    deleteConfirm: 'Adakah anda pasti mahu memadam audio ini?',
    roomName: 'Nama Podcast',
    addGuestTitle: 'TAMBAH PEMBICARA JEMPUTAN',
    showTime: 'Waktu Tayangan',
    startTime: 'Waktu Mula',
    endTime: 'Waktu Tamat',
    erorMsgImg: 'Sila pilih imej yang sah.',
    failedMsgImg: 'Gagal memuatkan imej. Sila cuba lagi!',
    failedMsgUpload: 'Gagal memuat naik kulit!',
    btnCoverUpload: 'Muat Naik Kulit',
    is_private: 'Persendirian',
    to_attach: 'Lampirkan Fail',
    file_attached: 'Fail Dilampirkan',
    main_event: 'Acara Utama',
    event: 'Acara',
    upload_pdf: 'Muat Naik PDF',
    portrait: 'Potret',
    landscape: 'Lanskap',
    import_from_library: 'Import Teks dari Perpustakaan Media',
    question_answer_ai: 'Soal/Jawab AI',
    take_maze: 'AMBIL MetaMaze',
    training: 'Latihan',
    select_transcribe_locale: 'Pilih Bahasa untuk Transkripsi',
    transcribe_limit: 'Sila Masukkan Minit Transkripsi',
    not_complete: 'Maklumat Marketplace Tidak Lengkap',
    complete: 'Maklumat Marketplace Lengkap',
    not_admin: 'Perlu Hak Pentadbir untuk Terbit ke Marketplace',
    no_course: 'Sila Masukkan Tajuk dan Pilih Imej untuk Aktifkan Marketplace',
    scorm_not_complete:
      'Sila Masukkan Tajuk dan Pilih Imej untuk Muat Naik Fail SCORM',
    not_found_maze: 'MetaMaze Tidak Ditemui',
    email_require: 'Emel Diperlukan',
    poll_required: 'Data Tinjauan Diperlukan',
    alert: 'Amaran!',
    warning: 'Amaran!',
    ok: 'Ok',
    cancel: 'Batal',
    done: 'Selesai',
    insert: 'Masukkan',
    private: 'Peribadi',
    public: 'Umum',
    no_connection: 'Sambungan Internet Terputus',
    switch: 'Tukar',
    share_screen: 'Kongsi Skrin',
    stop_share_screen: 'Henti Kongsi Skrin',
    share_screen_with_camera: 'Kongsi Skrin dengan Kamera',
    stop_share_screen_with_camera: 'Henti Kongsi Skrin dengan Kamera',
    camera_on: 'Kamera Hidup',
    camera_off: 'Kamera Mati',
    mic_on: 'Nyah Bisu',
    mic_off: 'Bisu',
    fullscreen: 'Skrin Penuh',
    live_now: 'Sedang Bersiaran',
    schedule_on: 'Jadual pada',
    organisations: 'Organisasi',
    org_groups: 'Kumpulan Organisasi',
    specific_user: 'Pengguna Tertentu',
    gif: 'GIF',
    unavailable: 'Tidak Tersedia',
    yes: 'Ya',
    no: 'Tidak',
    event_duration_message: 'Maksimum 300 minit (5 jam)',
    send_email: 'Hantar Pemberitahuan E-mel',
    admin_only: 'Hanya Pentadbir',
    join: 'Sertai',
    leave: 'Keluar',
    share: 'Kongsi',
    share_text:
      'Sila taip alamat e-mel orang yang anda mahu kongsikan fail ini.',
    share_text_title: 'Kongsi PDF',
    share_text_title_txt: 'Kongsi Teks',
    select_users: 'Pilih Pengguna',
    delete: 'Padam',
    attachment_event: 'Lampiran untuk acara:',
    transcribe_limit: 'Minit Transkripsi',
    monthly_transcribe: 'Had Transkripsi Bulanan:',
    enable_ai: 'Aktifkan AI:',
    enable_maze: 'Aktifkan MetaMaze:',
    media_service: 'Perkhidmatan Media',
    allow_others: 'Benarkan Orang Lain Menyunting',
    join_breakout_room: 'Sertai Bilik Pecahan',
    bio: 'Bio',
    linkedin: 'LinkedIn',
    select_org_report: 'Sila cari dan pilih organisasi untuk jana laporan.',
    org_image_not_found: 'Imej Tidak Ditemui',
    insert_text: 'Masukkan Teks',
    insert_question_answer: 'Soal/Jawab AI',
    modal_title2: 'Galeri Teks',
    my_text_library: 'Pustaka Teks Saya',
    ai: 'AI',
    public_text_library: 'Pustaka Teks Umum',
    organization_text_library: 'Pustaka Teks Organisasi',
    no_transcribed_text: 'Tiada Teks Ditranskripsi Ditemui',
    public_text_not_found: 'Teks Transkripsi Umum Tidak Ditemui',
    org_text_not_found: 'Teks Transkripsi Organisasi Tidak Ditemui',
    org_video_not_found: 'Video Tidak Ditemui',
    canva: 'Lakukan di Canva',
    canva_open: 'Klik sini untuk buka penyunting Canva.',
    pdf: 'PDF',
    txt: 'TEKS',
    human: 'Premium',
    shared_file: 'Fail anda telah berjaya dikongsi.',
    error_shared_file:
      'Terdapat masalah semasa berkongsi fail. Sila cuba lagi.',
    publish: 'Terbitkan',
    maze_scenes: 'Babak MetaMaze',
    pexel_images: 'Imej Pexel',
    group: 'Kumpulan',
    group_name: 'Nama Kumpulan',
    select_group: 'Pilih Kumpulan',
    search_maze: 'Cari MetaMaze',
    hosts: 'Hos',
    avg_score: 'Skor Purata (%)',
    maze_report: 'Laporan Maze',
    maze_view: 'Paparan Maze',
    title_maze: 'MetaMaze',
    author: 'Pengarang',
    match: 'Padanan Laluan',
    preview_mazeTitle: 'Tajuk: ',
    other: 'Lain-lain',
    total: 'JUMLAH',
    report_course: 'KURSUS',
    report_courses: 'KURSUS-KURSUS',
    report_event: 'ACARA',
    report_events: 'ACARA-ACARA',
    report_maze: 'MAZE',
    report_personalize_learning: 'PEMBELAJARAN DIPERSONALISASI',
    report_live_assessment: 'PENILAIAN LANGSUNG',
    report_live_assessments: 'PENILAIAN LANGSUNG',
    report_skill_journey: 'PERJALANAN KEMAHIRAN',
    skill_journey: 'Perjalanan Kemahiran',
    skill_journeys: 'Perjalanan Kemahiran',
    date: 'TARIKH: ',
    search_people: 'Cari Orang',
    passed: 'LULUS',
    failed: 'GAGAL',
    item: 'ITEM',
    type: 'JENIS',
    minimum_pass_score: 'SKOR LULUS MINIMUM',
    resources_count: 'JUMLAH SUMBER',
    back: 'KEMBALI',
    resources: 'SUMBER',
    time_spent: 'MASA DIGUNAKAN (MINIT)',
    detail: 'PERINCIAN',
    watched_time_mins: 'MASA DITONTON (MINIT)',
    personalize_learning: 'Pembelajaran Dipersonalisasi',
    result: 'Keputusan',
    assessment_title: 'Tajuk',
    marketPlace_graph: 'Graf Marketplace',
    attachments: 'Lampiran Tambahan',
    new_scorm_course: 'Muat Naik Kursus SCORM Baharu',
    upload_scorm_course: 'Muat Naik Kursus SCORM',
    new_maze: 'Cipta MetaMaze Baharu',
    new_skill_journey: 'Cipta Perjalanan Kemahiran',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Perjalanan Kemahiran',
    new_discussion_room: 'Cipta Podcast Baharu',
    title: 'Apa yang anda ingin lakukan hari ini?',
    build_course: 'Bina Kursus Saya',
    live_broadcast: 'Siaran Langsung',
    invite_users: 'Jemput Pengguna ke Organisasi Saya',
    build_voice_over: 'Bina Suara Latar Saya',
    view_reports: 'Lihat Laporan',
    upload_media: 'Muat Naik Media atau Kerja Saya dan Kongsikannya',
    main_menu: 'Menu Utama',
    get_started: 'MULAKAN',
    search_group: 'Cari Kumpulan Organisasi',
    ai_course: 'Kursus AI',
    search_user: 'Cari Nama Syarikat',
    no_maze: 'Tiada MetaMaze buat masa ini.',
    conference_event_title: 'Acara Persidangan',
    conference_event_subTitle: 'Acara Persidangan yang Telah Selesai',
    conference_event: 'Tiada acara persidangan buat masa ini.',
    no_skill: 'Tiada perjalanan kemahiran buat masa ini.',
    no_podcast: 'Tiada podcast buat masa ini.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Penilaian Langsung Lalu',
    no_live_assessment: 'Tiada penilaian langsung buat masa ini.',
    enrolled_courses: 'Kursus',
    my_video_channel: 'Saluran Video Saya',
    enrolled_liveEvents: 'Acara Langsung',
    sharebot: 'Sharebot',
    selected_language: 'Bahasa yang dipilih',
    shareSphere_game: 'Permainan ShareSphere',
    maze: 'MetaMaze',
    skill: 'Perjalanan Kemahiran',
    channel: 'Saluran',
    order: 'Pesanan',
    is_record: 'Rakaman',
    no_maze_found: 'Tiada MetaMaze ditemui.',
    maze_self_limit_reached: 'Had penilaian sendiri MetaMaze telah dicapai.',
    metamaze_two_times: 'Anda telah mengambil MetaMaze ini sebanyak 2 kali.',
    metamaze_two_times_no_result:
      'Anda telah mengambil MetaMaze ini sebanyak 2 kali. Keputusan anda tidak akan direkod selepas penilaian kali kedua.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Skor Minimum untuk Lulus',
    organization: 'Sila Pilih Organisasi',
    pass_score_mark: 'Sila Masukkan Markah Antara 1 hingga 100',
    maze_cloning_success: 'MetaMaze "<0/>" telah berjaya digandakan!',
    create_certificate: 'Cipta Sijil',
    create_badge: 'Cipta Lencana',
    certificate_added: 'Sijil Telah Ditambah.',
    badge_added: 'Lencana Telah Ditambah.',
    certificate_warning:
      'Anda tidak boleh mengedit sijil/lencana selepas ia diterbitkan!',
    created_course_plan:
      'Edit dan terbitkan kursus yang anda cipta serta rancang acara langsung',
    market_place_space: 'Pasar Digital',
    select_course_language: 'Pilih bahasa (Pilihan)',
    select_language: 'Pilih bahasa',
    file_upload: 'Muat naik fail',
    text: 'Tulis teks di sini…',
    attempts_count: 'Bilangan Percubaan Yang Boleh Diulang oleh Pengguna',
    no_of_people_placeholder: 'Bilangan Orang',
    back_to_maze: 'Kembali ke Senario MetaMaze',
    edit_maze: 'Edit Maze',
    wait: 'Sila tunggu...',
    retry: 'Cuba Lagi',
    publish_scorm_course: 'Terbitkan Kursus SCORM Anda',
    publish_maze: 'Terbitkan MetaMaze Anda',
    import: 'Import Elemen',
    answer_correct: 'Pilih Jawapan yang Betul',
    author_name: `Sila Masukkan Nama Penulis`,
    select_category: 'Sila Pilih Kategori',
    course_outline: 'Sila Masukkan Rangka Kursus',
    course_obj: 'Sila Masukkan Objektif Kursus',
    course_description: 'Sila Masukkan Penerangan Kursus',
    maze_outline: 'Sila Masukkan Rangka Maze',
    maze_obj: 'Sila Masukkan Objektif Maze',
    maze_description: 'Sila Masukkan Penerangan Maze',
    lessons: 'Sila Masukkan Bilangan Pelajaran',
    user_email_require: `Emel Pengguna Diperlukan`,
    team_size: `Saiz Pasukan Diperlukan`,
    enter_price: 'Sila Masukkan Harga (5 atau Lebih)',
    input_title_maze: 'Sila Masukkan Tajuk Maze',
    trainer_bio: 'Sila Masukkan Biografi Jurulatih',
    trainer_linkedin: 'Sila Masukkan Pautan LinkedIn Jurulatih',
    error_video: 'Sila Masukkan Bilangan Video',
    input_video_link: 'Sila Masukkan Pautan Video',
    number_of_video: 'bilangan video',
    number_of_lessions: 'bilangan pelajaran',
    no_of_people_in_conference: 'Berapa orang dalam persidangan?',
    transcribe_settings: 'Tetapan Transkripsi',
    transcribe: 'Transkripsi',
    cloning_maze: 'Menyalin MetaMaze...',
    id_number: 'Nombor ID',
    timezone: 'Zon Masa',
    edit_maze: 'Edit',
    delete_maze: 'Padam',
    view_maze: 'Lihat',
    create_metamaze: 'Cipta MetaMaze',
    metamaze_scenario: 'Senario MetaMaze',
    publish_metamaze: 'Tetapan Penerbitan',
    search_result: 'Hasil Carian:',
    search_for: 'Cari',
    search_no_result: '- Tiada hasil dijumpai!',
    channel_no_available: 'Tiada saluran tersedia!',
    this_card: 'Ini adalah kad',
    course_no_available: 'Tiada kursus tersedia!',
    exit_fullscreen: 'Keluar Skrin Penuh',
    bg_image: 'Imej Latar Belakang',
    introduction: 'Pengenalan',
    summary: 'Ringkasan',
    generate_introduction: 'Jana Pengenalan',
    generate_summary: 'Jana Ringkasan',
    bullet_points: 'Poin Utama',
    title_simulation: 'Sila Masukkan Nama Simulasi',
    view_generated_images: 'Lihat Imej Dihasilkan',
    image_transparency: 'Ketelusan Imej',
    template_bg_color: 'Warna Latar Templat',
    select_template_layout: 'Pilih Susun Atur Templat',
    reload_template: '(Muat Semula Templat)',
    are_you_sure_want_close: 'Adakah anda pasti mahu tutup?',
    all_your_changes_will_be_lost: 'Semua perubahan anda akan hilang.',
    please_checked_before_generated_video:
      'Sila pastikan semua syarat telah disemak sebelum menjana video.',
    voice_must_be_selected: 'Suara mesti dipilih',
    avatar_must_be_selected: 'Imej avatar mesti dipilih.',
    maximum_five_slides_try_again:
      'Ralat semasa mengekstrak imej dari fail anda. Pastikan terdapat maksimum 5 slaid dalam fail dan setiap slaid mempunyai nota. Sila cuba lagi!',
    back_to_upload: 'Kembali ke Muat Naik',
    uploading_file_to_server: 'Memuat naik fail anda ke pelayan',
    extracting_images_from_your_file: 'Mengekstrak imej daripada fail anda',
    upload_your_ppt_or_drag:
      'Muat naik fail pembentangan anda (.PPTX) atau seret ke sini.',
    maximum_five_slides_error:
      'Sila pastikan fail PowerPoint anda mempunyai maksimum 5 slaid dan setiap slaid mengandungi nota. Jika tidak, akan berlaku ralat.',
    number_of_questions_generated: 'Bilangan Soalan yang Akan Dihasilkan',
    quiz_page_this_cannot_be_done:
      'Adakah anda pasti mahu menambah kuiz pada halaman ini? Ini tidak boleh dibuat asal.',
    confirm_selection: 'Sahkan Pilihan',
    select_quiz_page: 'Pilih Halaman Kuiz',
    lesson_do_you_want_add_this_quiz:
      'Bahagian mana dalam pelajaran yang anda mahu tambah kuiz ini?',
    beginning_of_lesson: 'Pada Permulaan Pelajaran',
    end_of_lesson: 'Pada Akhir Pelajaran',
    currently_active_page: 'Halaman Aktif Semasa',
    finish: 'Selesai',
    upload_selection_file: 'Muat Naik Fail Seksyen',
    general_quiz: 'Kuiz Umum',
    manage_sequence: 'Urus Urutan',
    save_sequence: 'Simpan Urutan',
    new: 'Baru',
    in_progress: 'Sedang Berjalan',
    recommended_course: 'Kursus Disyorkan',
    up_coming: 'Akan Datang',
    past_live: 'Siaran Langsung Lepas',
    input_your_channel_name: 'Sila masukkan nama Saluran anda!',
    organization_place: 'Pasaran Organisasi',
    marketplace_report: 'Laporan Pasaran',
    story_writing: 'Penulisan Cerita',
    Ai_quiz: 'Kuiz AI',
    generate_quiz: 'Jana Kuiz',
    create_story: 'Cipta Cerita',
    change_layout_page: 'Anda akan menukar susun atur halaman ini.',
    change_layout_message:
      'Hanya teks, imej, latar belakang dan logo akan dikekalkan. Semua elemen lain akan dikeluarkan dari halaman.',
    reviews: 'Ulasan',
    tab_attachments: 'Lampiran',
    zoom_in: 'Zum Masuk',
    zoom_out: 'Zum Keluar',
    zoom_reset: 'Tetap Semula Zum',
    no_attachment: 'Tiada lampiran.',
    select_upload_simulation: 'Sila pilih/muat naik simulasi.',
    quiz_updated_successfully: 'Kuiz berjaya dikemas kini!',
    quizes: 'Kuiz-kuiz',
    trivia: 'Trivia',
    closing: 'Menutup...',
    products: 'Produk',
    ask_questions: 'Tanya soalan di sini...',
    course_information: 'Maklumat Kursus',
    course_assistance: 'Bantuan Pencipta Kursus',
    go_back: 'Kembali',
    ai_generate_content_progress: 'Menjana Kemajuan Kandungan',
    view_generate_content: 'Lihat Kandungan Dijana',
    generate_error: 'Ralat Penjanaan!',
    confirm_creating_course:
      'Adakah anda pasti mahu mencipta kursus menggunakan kandungan ini?',
    generate_content_automatically:
      'Ini akan menambah semua kandungan yang dijana sebagai pelajaran dan halaman ke kursus anda secara automatik.',
    quiz_created_successfully: 'Kuiz berjaya dicipta!',
    create_quiz: 'Cipta Kuiz',
    quiz_setting: 'Tetapan Kuiz',
    please_fill_quiz_setting: '* Sila isi semua medan dalam Tetapan Kuiz',
    question_list: 'Senarai Soalan',
    add_quiz_to_page: 'Tambah Kuiz ke Halaman',
    form_create_question: 'Borang Cipta Soalan',
    user_information_updated: 'Maklumat Pengguna Dikemaskini!',
    your_stripe_activete_to_continue:
      'Akaun Stripe anda tidak aktif. Sila sambungkan atau aktifkan untuk meneruskan.',
    connect_tripe: 'Sambungkan Stripe',
    certificate_sent_sucessfully:
      'Sijil telah dihantar ke emel anda dengan berjaya.',
    error_try_again: 'Ralat. Cuba Lagi!',
    error_delete_channel: 'Ralat semasa memadam saluran.',
    error_update_sub: 'Ralat semasa mengemas kini langganan.',
    end_time_cannot_start: 'Waktu tamat tidak boleh sebelum waktu mula.',
    start_date_time_interval: 'Tarikh dan masa mula diperlukan!',
    podcast_updated_successful: 'Podcast berjaya dikemaskini.',
    podcast_created_successful: 'Podcast berjaya dicipta.',
    podcast_published_successful: 'Podcast berjaya diterbitkan.',
    podcast_cover_updated: 'Kulit podcast dikemaskini.',
    new_podcast_details:
      'Podcast baharu akan dicipta pada podcast semasa dengan input baharu.',
    current_update_podcast: 'Kemas kini podcast semasa, muzik & cerita.',
    create_new_podcast: 'Cipta podcast baharu',
    publish_podcast_public_view: 'Terbitkan podcast untuk tontonan awam.',
    only_allowed_twenty_five_email: 'Hanya 25 emel dibenarkan.',
    only_allowed_five_email: 'Hanya 5 emel dibenarkan.',
    cover_is_required: 'Kulit diperlukan.',
    topic_is_required: 'Topik diperlukan.',
    delete_schedule: 'Padam Jadual',
    make_as_coaching: 'Tandakan sebagai Ketersediaan Bimbingan',
    manage_category: 'Urus Kategori',
    threshold: 'Ambang',
    threshold_popup:
      'Nilai ambang dalam peratusan(%), nilai yang akan mengaktifkan cadangan untuk kategori yang diberikan.',
    list_of_catagory: 'Senarai kategori',
    category_name: 'Nama Kategori',
    category_threshold: 'Ambang Kategori',
    play_game: 'Main Permainan',
    switching_organization: 'Menukar Organisasi...',
    coaching_session: 'Sesi Bimbingan',
    required_channel_id: 'ID Saluran diperlukan!',
    error_occured_try_again: 'Ralat berlaku. Cuba Lagi!',
    please_complete_marketplace_form: 'Sila lengkapkan borang pasaran!',
    upload_file_corrupt: 'Fail yang dimuat naik rosak.',
    course_not_published: 'Kursus belum diterbitkan!',
    error_request: 'Ralat dalam permintaan. Sila cuba lagi!',
    skill_request: 'Sila lengkapkan medan yang hilang!',
    error_occured: 'Ralat berlaku. Cuba Lagi!',
    show_time: 'Papar Masa',
    start_time: 'Waktu Mula',
    end_time: 'Waktu Tamat',
    room_name: 'Nama Podcast',
    add_guest_speaker: 'Tambah Penceramah Jemputan',
    cover_picture: 'Gambar Kulit',
    guest_speaker: 'Penceramah Jemputan',
    see_more: 'Lihat Lagi',
    see_less: 'Lihat Kurang',
    background: 'Latar Belakang',
    icon: 'Ikon',
    icon_size: 'Saiz Ikon',
    icon_color: 'Warna Ikon',
    only_text: 'Teks',
    change_bg: 'Tukar warna latar belakang',
    bg_color: 'Warna Latar Belakang',
    font_size: 'Saiz Fon',
    normal: 'Biasa',
    change_color: 'Tukar warna teks',
    slant_text: 'Teks Condong',
    text_radius: 'Jejari Teks',
    vertical_align: 'Penjajaran Menegak',
    horizontal_align: 'Penjajaran Mendatar',
    change_icon_color: 'Tukar warna ikon',
    upload_icon: 'Muat naik Ikon',
    upload_signature: 'Muat naik Tandatangan',
    add_another_sign: 'Tambah tandatangan lain',
    name_badges: 'Nama Lencana',
    should_less_150: 'harus 150 aksara atau kurang',
    your_badge: 'Lencana Anda',
    do_you_want_delete_badge: 'Adakah anda pasti mahu memadam lencana ini?',
    do_you_want_delete_cert: 'Adakah anda pasti mahu memadam sijil ini?',
    upload_logo: 'Muat naik Logo',
    name_of_cert: 'Nama Sijil',
    upload_cert: 'Kemas Kini Sijil',
    your_cert: 'Sijil Anda',
    translate_to: 'Terjemah kepada',
    select_file_attach: 'Pilih Fail untuk Dilampirkan',
    certificate: 'Sijil',
    badge: 'Lencana',
    publish_options: 'Pilihan Terbitan',
    publish_skills_journey: 'Terbitkan Perjalanan Kemahiran',
    videos: 'Video',
    generate_ai_video:
      'Proses penjanaan video mungkin mengambil masa. Anda akan diberitahu melalui emel setelah selesai.',
    trainer_information: 'Maklumat Jurulatih',
    promotional_video_link: 'Pautan Video Promosi',
    please_select: 'Sila pilih',
    image_name: 'Nama imej:',
    image_size: 'Saiz imej:',
    charecters_fifteen_less: '15 aksara atau kurang',
    leadership: 'Kepimpinan',
    text_arc: 'Lengkungan Teks',
    vertical: 'Menegak',
    horizontal: 'Mendatar',
    badge_history: 'Sejarah Lencana',
    templates: 'Templat',
    sign: 'Tandatangan',
    logo: 'Logo',
    certificate_history: 'Sejarah Sijil',
    please_wait: 'Sila Tunggu...',
    information: 'Maklumat',
    support_five_thousand_live_event:
      'Menyokong sehingga 5000 peserta untuk acara',
    support_ten_live_event: 'Menyokong sehingga 10 peserta video langsung',
    we_will_back_participant:
      'Kami akan kembali dengan acara yang menyokong lebih ramai peserta.',
    course_objectives: 'Objektif Kursus',
    course_outlines: 'Garis Panduan Kursus',
    price_dollor: 'harga (usd)',
    not_completed: 'Tidak Lengkap',
    enable_marketplace: 'Aktifkan Pasaran',
    enable_course_ai: 'Aktifkan Penciptaan Kursus dengan AI',
    enable_report_to_admin: 'Aktifkan Paparan Laporan kepada Pentadbir',
    enable_white_label: 'Aktifkan Label Putih',
    enable_eleven_labs_for_maze_play: 'Aktifkan Elevenlabs untuk Maze Play',
    enable_eleven_labs_for_maze_play_cloned: 'Aktifkan Suara Klon Elevenlabs',
    simulation_quiz: 'Kuiz Simulasi',
    bg_color_setting: 'Tetapan Warna Latar Belakang',
    color_preview: 'Pratonton Warna',
    choose_new_color: 'Pilih Warna Baru',
    remove_color: 'Buang Warna',
    apply_color: 'Guna Warna',
    elemeent_in_a_sceenario_page:
      'Anda tidak boleh menambah elemen lain dalam halaman senario. Sila cuba halaman lain atau buang senario dari halaman terlebih dahulu.',
    no_data_found: 'Tiada Data Dijumpai.',
    references: 'Rujukan',
    open_file: 'Buka Fail',
    showing_result: 'Menunjukkan Keputusan:',
    fiften_day_free_trail: 'Percubaan Percuma 15 Hari',
    your_browser_does_not_support: 'Pelayar anda tidak menyokong elemen audio.',
    podcast_desc: 'Deskripsi Podcast',
    input_podcast_desc: 'Sila masukkan deskripsi podcast',
    podcast_obj: 'Objektif Podcast',
    input_podcast_obj: 'Sila masukkan objektif podcast',
    podcast_outline: 'Rangka Podcast',
    input_podcast_outline: 'Sila masukkan rangka podcast',
    add_file: 'Tambah Fail',
    generate_podcast_audio: 'Jana Audio Podcast',
    generate_uploaded_file_input_parameter:
      'Menjana kandungan berdasarkan fail yang dimuat naik dengan parameter input yang diberikan.',
    go_backe_generation_state: 'Kembali ke keadaan penjanaan kandungan.',
    create_ai_powered_podcast:
      'Cipta episod podcast berkuasa AI dengan audio yang dijana.',
    generate_voice_for_all_podcast:
      'Sila jana suara untuk semua episod podcast',
    create_podcast_episode: 'Cipta Episod Podcast',
    voice_name: 'Nama Suara',
    input_custom_name: 'Sila masukkan nama tersuai!',
    enter_custom_name: 'Masukkan nama suara tersuai',
    upload_complete: 'Muat naik selesai',
    uploading_in_progress: 'Muat naik sedang dijalankan...',
    podcast_stream_content: 'Kandungan Strim Podcast',
    upload_podcast_cover: 'Sila muat naik muka depan podcast!',
    enter_podcast_name: 'Sila masukkan nama podcast!',
    podcast_topic: 'Topik Podcast',
    enter_podcast_topic: 'Sila masukkan topik podcast!',
    enter_podcast_desc: 'Sila masukkan deskripsi podcast!',
    number_of_speaker: 'Bilangan Penceramah',
    select_the_number_of_speaker: 'Sila pilih bilangan penceramah!',
    number_of_episode: 'Bilangan Episod',
    input_number_of_episode: 'Sila masukkan bilangan episod!',
    podcast_length: 'Panjang Podcast',
    select_the_podcast_length: 'Sila pilih panjang podcast!',
    short_podcast: 'Pendek (5-10 minit)',
    medium_podcast: 'Sederhana (15-18 minit)',
    long_podcast: 'Panjang (18+ minit)',
    name_of_host: 'Nama Pengacara',
    enter_host_name: 'Sila masukkan nama pengacara!',
    guest_name: 'Nama Tetamu',
    enter_guest_name: 'Sila masukkan nama tetamu!',
    choose_speaker_tone: 'Pilih Nada Suara Penceramah',
    enter_speaker_tone: 'Sila pilih nada podcast!',
    informal: 'Tidak formal',
    formal: 'Formal',
    serious: 'Serius',
    light_humor: 'Humor Ringan',
    casual: 'Santai',
    select_content_source: 'Pilih Sumber Kandungan',
    from_internet: 'Dari Internet',
    upload_pdf_internet: 'Muat naik PDF atau Dokumen Dalaman',
    note: 'Nota:',
    podcast_content_will_be_automatically_generated:
      'Kandungan podcast akan dijana secara automatik menggunakan sumber internet yang dipercayai.',
    upload_or_select_file: 'Sila muat naik atau pilih fail!',
    podcast_eposode_title: 'Tajuk Episod Podcast',
    enter_podcast_title: 'Sila masukkan tajuk episod!',
    podcast_episode_des: 'Deskripsi Episod Podcast',
    enter_podcast_episode_des: 'Sila masukkan deskripsi episod!',
    voice: 'Suara',
    music: 'Muzik',
    select_music: 'Pilih muzik',
    play_the_music: 'Mainkan muzik',
    stop_the_music: 'Hentikan muzik',
    context: 'Konteks',
    generate_audio_content_selected_voice:
      'Ini akan menjana audio berdasarkan kandungan dan suara yang dipilih.',
    required_field_before_submitting:
      'Sila isi semua ruangan yang diperlukan sebelum menghantar.',
    regenerate_voice: 'Menjana Semula Suara',
    generate_voice: 'Jana Suara',
    your_browser_does_not_suppot: 'Pelayar anda tidak menyokong elemen audio.',
    are_sure_leave_podcast: 'Adakah anda pasti mahu meninggalkan podcast?',
    broadcast_ongoing:
      'Siaran sedang berlangsung. Adakah anda pasti mahu meninggalkan halaman ini?',
    brodcaster_unavailable: 'Penyiar tidak tersedia buat masa ini.',
    setting_calender_for_booking: 'Menetapkan Kalendar untuk Tempahan',
    add_calender: 'Tambah Kalendar',
    waiting_join_host: 'Menunggu pengacara untuk menyertai...',
    no_reviews_found: 'Tiada Ulasan Dijumpai.',
    rated_already: 'Anda telah menilai acara langsung ini.',
    downlink_png: 'muat_turun_png',
    downlink_jpg: 'muat_turun_jpg',
    donwload_file_format: 'Sila pilih format fail yang ingin anda muat turun.',
    crashed_event:
      'Acara ini telah rosak. Anda perlu mencipta acara baharu. Maaf atas kesulitan ini.',
    prompt: 'Arahan:',
    generated_image: '🚀 Menjana imej anda... Sila tunggu.',
    download_add: 'Muat turun semua',
    setting_generator: 'Menetapkan Penjana',
    enter_image_prompt: 'Sila masukkan arahan imej',
    image_prompt: 'Masukkan arahan imej anda',
    negative_prompt: 'Arahan Negatif',
    negative_image_prompt: 'Masukkan arahan imej negatif anda',
    number_output: 'Bilangan Hasil',
    enter_number_output: 'Sila masukkan bilangan hasil',
    image_style: 'Sila pilih gaya untuk imej',
    output_format: 'Format Hasil',
    seeds: 'Benih',
    enter_seeds: 'Sila masukkan bilangan benih',
    performance_mode: 'Mod Prestasi',
    quality: 'Kualiti',
    speed: 'Kelajuan',
    balanced: 'Seimbang',
    guidance_scale: 'Skala Panduan',
    enter_guidance: 'Sila masukkan skala panduan',
    select_image: 'Sila pilih imej.',
    image_prmt: 'Arahan Imej',
    generate_image_list_empty: 'Senarai imej yang dijana kosong.',
    knowledge_center_tooltrip_des:
      'Dapatkan jawapan ringkas dan tepat dari segi konteks untuk pelbagai soalan termasuk pengetahuan umum. Jawapan diperoleh daripada maklumat umum di internet oleh model AI yang dilatih daripada pelbagai teks internet.',
    contexts: 'Konteks',
    ai_processing_video_sharebot:
      'Pemprosesan AI terhadap video akan mengambil masa kira-kira 24 jam untuk disiapkan dan dipaparkan di Sharebot.',
    remove_sharebot_video:
      'Untuk membuang rujukan video kepada Sharebot, sila padam transkrip bersama video tersebut.',
    remove_sharebot_video_audio:
      'Memadam transkrip akan menghapuskan rujukan video/audio kepada Sharebot, tetapi video masih akan muncul dalam pustaka media/saluran.',
    monthly_live_stream:
      'Untuk menukar had penstriman langsung bulanan anda sila hubungi',
    monthly_transcribe_limit:
      'Untuk menukar had transkripsi bulanan anda sila hubungi',
    must_be_one_to_three_hundred: 'Mesti antara 1 hingga 300 minit.',
    all_field_required: 'Semua ruangan adalah wajib.',
    duration_minute: 'Tempoh (maksimum 300 minit)',
    gender: 'Jantina',
    select_gender: 'Pilih Jantina',
    accent: 'Loghat',
    select_accent: 'Pilih Loghat',
    create_voice: 'Cipta Suara',
    enter_voice_name: 'Masukkan Nama Suara',
    select_voice_gender: 'Sila pilih jantina suara',
    upload_voice: 'Muat Naik Suara Anda',
    upload_voice_mp_three: 'Muat naik suara anda (.mp3)',
    cloned_voice: 'Suara yang Diklonn',
    voice_type: 'Jenis Suara',
    select_voice_type: 'Pilih Jenis Suara',
    sharelook_stand: 'Standard',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Tersuai (Klon Suara)',
    create_auto_flow: 'Cipta aliran automatik',
    how_many_layers: 'Berapa lapisan',
    verify_selection: 'Sahkan Pilihan',
    uploaded_successful: 'Muat naik berjaya',
    upload_failed: 'Muat naik gagal',
    upload_only_five_mb: 'Muat Naik Kandungan (fail PDF, maksimum 5)',
    docs_from_org_library: 'Guna Dokumen dari Perpustakaan Organisasi',
    failed_maze_generate: 'Gagal menjana maze. Sila cuba lagi.',
    generate_metamaze: 'Menjana MetaMaze...',
    metamaze_being_generated:
      'MetaMaze anda sedang dijana. Anda akan dimaklumkan melalui emel apabila proses selesai.',
    metamaze_generate_successfully: 'MetaMaze Berjaya Dihasilkan!',
    metamaze_with_proceed: 'Anda kini boleh meneruskan dengan metamaze.',
    ai_metamaze_generate: 'Penjanaan MetaMaze oleh AI',
    what_kind_maze_create: 'Jenis maze yang ingin anda cipta?',
    manual_metamaze_creation: 'Cipta MetaMaze Secara Manual',
    manually_maze_customizing_scnario:
      'Cipta maze secara manual dengan menyesuaikan senario dan pokok pilihan',
    maze_ai_generated: 'Maze dijana secara automatik oleh AI',
    unmark_deadend: 'Nyah tanda jalan mati',
    mark_deadend: 'Tanda sebagai jalan mati',
    select_multiple_image_for_scenario:
      'Anda boleh memilih berbilang imej untuk senario.',
    select_your_image: 'Imej yang anda pilih',
    click_to_preview: 'Klik untuk pratonton',
    are_you_sure_delete_image: 'Adakah anda pasti ingin memadam imej ini?',
    select_image_from_library: 'Pilih Imej dari Perpustakaan Media',
    uploading_video: 'Memuat naik video...',
    tree_node_type: 'Jenis Node Pokok',
    correct_option_scenario: 'Pilihan atau Senario Betul',
    incorrect_option: 'Pilihan Salah',
    option_scenario_without_text: 'Pilihan atau Senario tanpa sebarang teks',
    dead_end: 'Jalan Mati (Sempadan Merah)',
    correct_path: 'Laluan Betul',
    incorrect_path_not_selected_correct_option_path:
      'Laluan Salah / Laluan di mana pilihan betul tidak dipilih.',
    double_click_on_tree_node:
      'Apabila anda klik dua kali pada node pokok, editor teks akan menatal secara automatik untuk memaparkan kandungan node tersebut.',
    add_scenario: 'Tambah Senario',
    add_option: 'Tambah Pilihan',
    an_error_occured: 'Ralat telah berlaku:',
    download_summary: 'Muat Turun Ringkasan',
    step_wise_analysis: 'Analisis Mengikut Langkah',
    step: 'Langkah',
    upload_csv_file: 'Muat Naik Fail CSV',
    download_template_to_import: 'Muat turun templat contoh untuk diimport',
    please_input_email: 'Sila masukkan emel.',
    email_at_least_three_characters: 'Emel mesti sekurang-kurangnya 3 aksara.',
    email_cannot_be_empty: 'Emel tidak boleh kosong.',
    input_email_in_new_line: 'Sila masukkan emel (satu emel pada setiap baris)',
    role: 'Peranan',
    select_role: 'Sila pilih Peranan',
    select_group: 'Sila pilih Kumpulan',
    identification_number: 'Nombor pengenalan (Pilihan)',
    add_identification_number: 'Sila tambah nombor pengenalan',
    pie_chart_of_all_categories:
      'Carta pai semua kategori berdasarkan penggunaannya dalam Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Jumlah soalan ShareSphere yang dijawab oleh pengguna dalam organisasi semasa, dengan kategori ini dan keputusan kejayaan serta kegagalannya.',
    voice_style_over_the_text: `Di mana anda boleh menggunakan banyak gaya suara ke atas teks yang anda taip bla bla bla Lorem Ipsum hanyalah teks rekaan dalam industri percetakan dan taip. Lorem Ipsum telah menjadi teks rekaan standard industri sejak 1500-an.`,
    input_your_question: 'Sila masukkan soalan anda!',
    make_me_sales_manager:
      'cth: Apa yang boleh menjadikan saya pengurus jualan',
    enter_the_number_relevant_document:
      'Masukkan bilangan dokumen yang berkaitan',
    please_wait_loading_result: 'Sila tunggu hasil dimuatkan...',
    no_result_found: 'Tiada hasil dijumpai, cuba tanya soalan lain',
    browser_doesnot_support_iframes: 'Pelayar anda tidak menyokong iframes',
    total_duration: 'Jumlah Tempoh',
    number_of_messages: 'Bilangan Mesej',
    search_result: 'Keputusan carian',
    count_result: '(1244 keputusan)',
    your_other_interests: 'Minat lain anda',
    your_total_score: 'Skor Keseluruhan Anda',
    add_a_question: '+tambah soalan',
    travia_question_empty: 'Senarai soalan Travia kosong.',
    video_generation_is_on_queue: 'Penjanaan video anda sedang dalam giliran!',
    checking_video_status: 'Memeriksa status video...',
    total_quizzes: 'Jumlah Kuiz',
    number_of_votes: 'Bilangan Undian',
    total_events: 'Jumlah Acara',
    number_of_rates: 'Bilangan Penilaian',
    number_of_likes: 'Bilangan Suka',
    all_courses: 'Semua Kursus',
    total_questions: 'Jumlah Soalan',
    no_skill_journey: 'Tiada perjalanan kemahiran tersedia!',
    search_no_results: '- tiada hasil carian tersedia!',
    no_image_generated: 'Tiada Imej Dihasilkan!',
    all_topic_in_this_lesson:
      'Semua topik dalam pelajaran ini akan dipadam. Ini tidak boleh dipulihkan.',
    content_has_been_generated: 'Kandungan telah dijana untuk topik ini.',
    update_course_template: 'Kemaskini Templat Kursus',
    add_course_template: 'Tambah Templat Kursus',
    create_course_now: 'Cipta Kursus Sekarang',
    preview_course: 'Pratonton Kursus',
    layout: 'Tataletak',
    import_from_youtube: 'Import dari Youtube',
    my_media_library: 'Perpustakaan Media Saya',
    bg_added: 'Latar belakang ditambah',
    add_bg: 'Tambah Latar Belakang',
    booked_schedule: 'Jadual Telah Ditempah',
    add_schedule: 'Tambah Jadual',
    are_you_delete_schedule: 'Adakah anda pasti mahu memadam jadual ini?',
    add_task: 'Tambah Tugasan',
    update_calender: 'Kemas kini Kalendar',
    manage_cookies: 'Urus Kuki',
    cookie_banner_text:
      'Kami menggunakan kuki untuk meningkatkan pengalaman pelayaran anda, menganalisis trafik laman web, dan memperibadikan kandungan. Privasi anda penting bagi kami.',
    accept_all_cookies: 'Terima Semua Kuki',
    reject_all: 'Tolak Semua',
    customize: 'Sesuaikan',
    cookie_preferences_title: 'Keutamaan Kuki & Tetapan Privasi',
    privacy_subtitle:
      'Privasi anda penting bagi kami. Pilih kuki yang anda selesa untuk diterima. Anda boleh menukar tetapan ini pada bila-bila masa.',
    save_choices: 'Simpan Pilihan Saya',
    strictly_necessary: 'Sangat Penting',
    strictly_necessary_desc:
      'Kuki ini penting untuk memastikan laman web berfungsi dengan betul. Ia membolehkan fungsi asas seperti navigasi halaman, penghantaran borang, dan akses ke kawasan selamat. Laman web tidak dapat berfungsi dengan betul tanpa kuki ini.',
    analytics_performance: 'Analitik & Prestasi',
    analytics_performance_desc:
      'Kuki ini membantu kami memahami bagaimana pelawat berinteraksi dengan laman web kami dengan mengumpul dan melaporkan maklumat secara anonim. Ini membantu kami memperbaiki prestasi laman web dan pengalaman pengguna.',
    advertising_marketing: 'Pengiklanan & Pemasaran',
    advertising_marketing_desc:
      'Kuki ini digunakan untuk menjadikan mesej pengiklanan lebih relevan untuk anda. Ia mengelakkan iklan yang sama muncul berulang kali dan memastikan iklan dipaparkan dengan betul kepada pengiklan.',
    tracking_social: 'Penjejakan & Media Sosial',
    tracking_social_desc:
      'Kuki ini membolehkan fungsi lanjutan dan penyesuaian, seperti ciri media sosial dan kandungan yang diperibadikan. Ia boleh ditetapkan oleh kami atau penyedia pihak ketiga.',
    functional: 'Fungsian',
    functional_desc:
      'Kuki ini membolehkan fungsi lanjutan seperti sokongan sembang, bantuan langsung, dan ciri interaktif lain yang meningkatkan pengalaman anda di laman web kami.',
    your_rights: 'Hak Anda:',
    rights_description:
      'Anda boleh menarik balik persetujuan anda pada bila-bila masa, mengakses data anda, atau meminta pemadaman data pada bila-bila masa.',
    withdraw_consent: 'Tarik Semua Persetujuan',

    how_many_options: 'Berapa banyak pilihan',
    add_content: 'Tambah Kandungan',
    downloads_center: 'Pusat Muat Turun',
    sharelook_help_center: 'Pusat Bantuan Sharelook',
    channel_outline: 'Garis Besar Saluran',
    channel_objectives: 'Objektif Saluran',
    no_sop_available: 'Tiada senarai SOP tersedia.',
    generate_world_summary: 'Hasilkan Senario',
    world_scenario: 'Senario Dunia Sebenar',
    drag_icon_hint: 'Petua: Seret ikon ke kanvas untuk meletakkannya',
    drag_text_hint: 'Petua: Seret teks ke kanvas untuk meletakkannya',
    edit_badge: 'Edit Lencana',
    create_new_badge: 'Lencana Baru',
    select_video_preview: 'Pilih video untuk pratonton',
    certificate_title_required: 'Tajuk Sijil diperlukan',
    discard_changes: 'Buang Perubahan',
    edit_certificate: 'Edit Sijil',
    add_another_logo: 'Tambah Logo Lain',
    optional: 'Pilihan',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Cipta Quest Baru',
    quest_filter_title: 'Quest',
    sharelook_assistance: 'Bimbingan Sharelook',
    upload_scorm_zip: 'Muat Naik SCORM Zip',
    only_letters_numbers_space_dot_allowed:
      'Hanya huruf, nombor, ruang, dan titik dibenarkan!',
    video_playing: 'Sedang Main',
    course_price_message: `*Kursus ini hanya akan diterbitkan kepada pengguna dalam organisasi dan tidak boleh dijual semula di pasaran.`,
    lesson_must_be_positive: 'Bilangan Pelajaran mesti lebih besar daripada 1',
    btn_proceed: 'Teruskan',
    rule_select_music: 'Sila pilih muzik',
    course_info: 'Maklumat Kursus',
    content_selection: 'Pemilihan Kandungan',
    course_content_source: 'Sumber Kandungan Kursus',
    choose_how_to_source:
      'Pilih bagaimana untuk mendapatkan kandungan bagi kursus ini:',
    automatic_selection: 'Pemilihan Automatik',
    system_will_automatically_select_relavant_documents:
      'Sistem akan secara automatik memilih dokumen yang berkaitan dari perpustakaan anda',
    manual_selection: 'Pemilihan Manual',
    choose_specific_documents_from_your_library:
      'Pilih dokumen tertentu dari perpustakaan anda',
    upload_files: 'Muat Naik Fail',
    upload_new_documents:
      'Muat naik dokumen baru (PDF, DOC, DOCX, PPT, PPTX, TXT) - Maksimum 5 fail',
    file: 'fail',
    ready_to_upload: 'sedia untuk dimuat naik',
    clear_all: 'Kosongkan Semua',
    confirm_course_wide_premiew: 'Sahkan Pratonton Keseluruhan Kursus',
    generate_course_preview: 'Hasilkan Pratonton Kursus',
    instructions_across_the_course_to_generate:
      'Kami akan menggunakan arahan anda ke seluruh kursus untuk menghasilkan pratonton. Semak semuanya dahulu sebelum memilih untuk menyimpan atau membuang perubahan.',
    instruction_to_preview_course_wide:
      'Arahan untuk pratonton keseluruhan kursus:',
    edit_content: 'Edit Kandungan',
    manage_course_template: 'Urus Templat Kursus',
    undo: 'Batal',
    apply_changes: 'Terapkan Perubahan',
    characters: 'aksara',
    apply_all: 'Terapkan Semua',
    apply_to_all: 'Terapkan kepada Semua',
    use_this_content: 'Gunakan Kandungan Ini',
    original: 'Asal',
    edited: 'Diedit',
    edited_content_preview: 'Pratonton Kandungan Yang Diedit',
    apply_edits_to_all_topices: 'Terapkan suntingan ke semua topik?',
    current_editing_instructions_across_the_whole_course:
      'Ini akan menggunakan arahan suntingan semasa ke seluruh kursus. Anda boleh menyemak pratonton gabungan sebelum menyimpan.',
    edit_content_instructions: 'Arahan Sunting Kandungan',
    generate_content_for_this_topic_instruction:
      'Hasilkan kandungan untuk topik ini menggunakan arahan anda',
    descrip_edit_content:
      'Terangkan bagaimana untuk menyunting kandungan ini (contoh: ringkaskan, permudahkan, ubah ayat)',
    try_short_clear_direcctives: `Cuba arahan ringkas dan jelas. Contoh: "kurangkan kepada 100 perkataan, kekalkan poin utama", "permudahkan bahasa", "buat lebih padat dan buang isi tambahan".`,
    we_preserve_the_core_meaning:
      'Kami mengekalkan makna utama semasa menggunakan arahan anda.',
    feedback_optional: 'Maklum Balas (Pilihan)',
    write_your_feedback_here: 'Tulis maklum balas anda di sini',
    from_web: 'Dari Web',
    from_desktop: 'Dari Desktop',
    pleae_wait_processing: 'Sila tunggu, sedang diproses...',
    create_simulation_from_screen_capture:
      'Cipta Simulasi dari Tangkapan Skrin',
    sharelook_not_found: 'ShareLook Tidak Dijumpai',
    sharelook_screen_capture_application_not_be_opened:
      'Aplikasi Tangkapan Skrin ShareLook tidak dapat dibuka. Mungkin tidak dipasang di komputer anda.',
    download_sharelook: 'Muat Turun ShareLook',
    launch_sharelook_application: 'Jalankan Aplikasi ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Ini akan membuka aplikasi ShareLook untuk tangkapan skrin.',
    sharelook_dosenot_open:
      'Jika ShareLook tidak dibuka, mungkin tidak dipasang di komputer anda.',
    open_sharelook: 'Buka ShareLook',
    download_app: 'Muat Turun Aplikasi',
    background_image_setting: 'Tetapan Imej Latar Belakang',
    current_image: 'Imej Semasa',
    change_image: 'Tukar Imej',
    remove_image: 'Alihkan Imej',
    no_background_image_selected: 'Tiada imej latar dipilih',
    add_image: 'Tambah Imej',
    this_will_open_for_screen_recording:
      'Ini akan membuka aplikasi ShareLook untuk rakaman skrin.',
    ai_image_generation: 'Penjanaan Imej AI',
    image_edit: 'Edit Imej',
    text_to_image: 'Teks ke Imej',
    output_gallary: 'Galeri Output',
    instant_generation: 'Sedia untuk Penjanaan Segera',
    prompt_and_unleash_the_power: 'Masukkan arahan dan lepaskan kuasa AI',
    use_this_image: 'Gunakan Imej Ini',
    error_generating: 'Ralat semasa menjana.',
    generation_tips: 'Tips Penjanaan',
    detailed_descriptions_for_more_accurate_results:
      'Gunakan deskripsi terperinci untuk hasil yang lebih tepat',
    reference_image: 'Imej Rujukan',
    select_pixel_image: 'Pilih Imej Pixel',
    max_mb: 'Maksimum 50MB',
    please_enter_text_to_appear_image:
      'Sila masukkan teks yang akan muncul pada imej',
    enter_text_to_apear_in_the_image:
      'Masukkan teks yang akan muncul pada imej',
    generate_image: 'Jana Imej',
    prompt_assistant: 'Pembantu Prompt',
    generate_image_using_suggested_prompt:
      'Jana Imej Menggunakan Arahan Yang Dicadangkan',
    talk_to_ai_about_the_image_generate:
      'Bercakap dengan AI mengenai imej yang ingin dijana',
    ask_for_prompt_suggestions: 'Minta cadangan arahan...',
    enter_a_search_term_to_find_stock_images:
      'Masukkan kata kunci untuk mencari imej stok',
    choose_your_content_source: 'Pilih sumber kandungan anda:',
    upload_new_document_from_your_device:
      'Muat naik dokumen baru dari peranti anda',
    automatic_library_selection: 'Pemilihan Perpustakaan Automatik',
    system_automatically_selects_relevant_document:
      'Sistem secara automatik memilih dokumen yang relevan',
    manual_library_selection: 'Pemilihan Perpustakaan Manual',
    generate_content: 'Jana Kandungan',
    add_to_current_page: 'Tambah ke Halaman Semasa',
    generate_bullet_points: 'Jana Poin Peluru',
    generating: 'Sedang Menjana',
    this_may_take_a_few_moments: 'Ini mungkin mengambil sedikit masa',
    apply_to_page: 'Terapkan ke Halaman',
    scenario_escription: 'Penerangan Senario:',
    feedback: 'Maklum Balas',
    form_mode: 'Mod Borang',
    chat_mode: 'Mod Sembang',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Ini akan menjana sambungan bagi cerita yang dipilih menggunakan AI.',
    continue_this_story_question: 'Teruskan Cerita Ini?',
    continue_this_story: 'Teruskan Cerita Ini',
    what_will_happen: 'Apa yang akan berlaku:',
    the_ai_will_analyze_the_existing_story_content:
      'AI akan menganalisis kandungan cerita sedia ada',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Menjana sambungan semula jadi yang mengikuti nada dan gaya yang sama',
    create_new_content_that_build_upon_the_current_narrative:
      'Mewujudkan kandungan baharu yang membina berdasarkan naratif semasa',
    this_process_may_take_a_few_moments_to_complete:
      'Proses ini mungkin mengambil sedikit masa untuk disiapkan.',
    no_existing_stories_found_for_this_course:
      'Tiada cerita sedia ada ditemui untuk kursus ini.',
    create_your_first_story: 'Cipta Cerita Pertama Anda',
    existing_stories: 'Cerita Sedia Ada',
    create_new_story: 'Cipta Cerita Baharu',
    tone: 'Nada',
    style: 'Gaya',
    genre: 'Genre',
    loading_your_stories: 'Memuatkan cerita anda...',
    edit_story: 'Edit Cerita',
    story_preferences: 'Keutamaan Cerita',
    please_input_your: 'Sila masukkan',
    add_character_names_and_press_enter: 'Tambah nama watak dan tekan Enter',
    select_or_type_your: 'Pilih atau taip',
    enter_your: 'Masukkan',
    position_of_the_story_in_the_lesson:
      'Kedudukan cerita dalam pelajaran. Cerita akan ditambah sebagai blok pada kedudukan yang ditentukan.',
    save_previous_content_on_the_pages:
      'Simpan kandungan terdahulu pada halaman',
    the_existing_content_in_the_selected_pages:
      'Kandungan sedia ada dalam halaman yang dipilih akan digantikan dengan cerita yang dijana.',
    real_world_scenario: 'Senario Dunia Sebenar',
    add_optional_instructions:
      'Tambah arahan pilihan (nada, panjang, khalayak, dsb.)',
    ready_to_enerate_your_real_world_scenario:
      'Sedia Menjana Senario Dunia Sebenar Anda',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Klik "Jana Senario Dunia Sebenar" untuk mencipta senario realistik berdasarkan kandungan pelajaran anda.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'AI akan menganalisis topik dan kandungan pelajaran anda',
    generate_a_practical_real_world_scenario:
      'Menjana senario dunia sebenar yang praktikal',
    you_can_then_edit_and_customize_the_result:
      'Anda kemudiannya boleh mengedit dan menyesuaikan hasilnya',
    add_it_as_a_new_page_to_your_lesson:
      'Tambahkan ia sebagai halaman baharu dalam pelajaran anda',
    regenerate_with_instructions: 'Jana Semula dengan Arahan',
    add_real_world_scenario: 'Tambah Senario Dunia Sebenar',
    generate_real_world_scenario: 'Jana Senario Dunia Sebenar',
    simulation_has_been_stopped: 'Simulasi telah dihentikan!',
    loading_simulation: 'Memuatkan Simulasi...',
    you_have_exhausted_all_the_attempts:
      'Anda telah menggunakan semua percubaan',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Kaji senario pada halaman ini dan pilih jawapan yang betul daripada pilihan di bawah.',
    attempts_limit_reached:
      'Had percubaan telah dicapai. Anda boleh bermain semula tetapi markah anda tidak akan disimpan.',
    play_again: 'Main Semula',
    import_music_from_computer: 'Import muzik dari komputer.',
    more: 'lagi',
    no_badge_yet: 'Tiada lencana lagi',
    competition_filter: 'Penapis Pertandingan',
    global_leaderboard: 'Papan Kedudukan Global',
    placeholder_for_the_global_leaderboard:
      'Ini ialah ruang letak untuk Papan Kedudukan Global.',
    badge_editor: 'Penyunting Lencana',
    adjust_the_appearance_of_this_badge_icon:
      'Laraskan penampilan ikon lencana ini. Perubahan hanya digunakan untuk lencana ini.',
    badge_style: 'Gaya Lencana',
    the_image_must_be_pixels: 'Imej mesti berukuran 200x200 piksel.',
    badge_name: 'Nama Lencana',
    badge_descrription: 'Penerangan Lencana',
    enter_badge_criteria: 'Masukkan kriteria lencana',
    discard: 'Buang',
    badge_enable: 'Lencana Dihidupkan',
    award_users_with_badges_to_highlight_the_milestones:
      'Anugerahkan pengguna dengan lencana untuk menyerlahkan pencapaian dalam perjalanan pembelajaran mereka.',
    badge_types: 'Jenis Lencana',
    enable_or_disable_specific_badge_types_for_your_users:
      'Hidupkan atau matikan jenis lencana tertentu untuk pengguna anda.',
    levels_enabled: 'Tahap Dihidupkan',
    level_rules: 'Peraturan Tahap',
    points: 'Mata',
    add_new_level: 'Tambah Tahap Baharu',
    add_level: 'Tambah Tahap',
    points_enabled: 'Mata Dihidupkan',
    learning_activities_and_encourage_healthy_competition:
      'Anugerahkan pengguna dengan mata untuk aktiviti pembelajaran yang berbeza dan galakkan persaingan sihat.',
    award_points: 'Anugerahkan Mata',
    the_following_equates_the_value_of_one_item_completion:
      'Berikut mewakili nilai bagi satu item yang disiapkan',
    general: 'Umum',
    others: 'Lain-lain',
    certificate: 'Sijil',
    quiz_passed: 'Kuiz Lulus',
    tip_approved: 'Petua Diluluskan',
    tip_liked: 'Petua Disukai',
    rewards: 'Ganjaran',
    offer_discounts_when_learners_achieve:
      'Tawarkan diskaun apabila pelajar mencapai sejumlah mata, lencana atau tahap tertentu.',
    give_rewards: 'Beri Ganjaran',
    discount_course_purchases_by: 'Diskaun pembelian kursus sebanyak',
    with_points_more_than: 'dengan mata melebihi',
    with_badges_more_than: 'dengan lencana melebihi',
    with_level_upwards_more_than: 'dengan tahap ke atas melebihi',
    leaderboard: 'Papan Kedudukan',
    leaderboard_enabled: 'Papan Kedudukan Dihidupkan',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Papan kedudukan memberikan pengguna gambaran tentang kemajuan pembelajaran mereka dari segi mata berbanding pengguna lain.',
    show_levels: 'Tunjukkan Tahap',
    show_points: 'Tunjukkan Mata',
    show_badges: 'Tunjukkan Lencana',
    show_courses: 'Tunjukkan Kursus',
    show_certificates: 'Tunjukkan Sijil',
    leaderboard_settings: 'Tetapan Papan Kedudukan',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Sediakan pengalaman papan kedudukan yang menarik untuk meningkatkan motivasi pelajar.',
    award_users_with_points_for_different_learning_activities:
      'Anugerahkan pengguna dengan mata untuk pelbagai aktiviti pembelajaran.',
    badge_set: 'Set Lencana',
    choose_the_type_of_badges_your_users:
      'Pilih jenis lencana yang akan diterima pengguna anda semasa mereka belajar.',
    levels: 'Tahap',
    Levels_represent_the_stages:
      'Tahap mewakili peringkat dalam perjalanan pembelajaran pengguna.',
    enabled: 'Dihidupkan',
    disabled: 'Dimatikan',
    quick_select: 'Pilih Pantas',
    yesterday: 'Semalam',
    last_week: 'Minggu Lepas',
    Last_month: 'Bulan Lepas',
    last_quarter: 'Suku Tahun Lepas',
    historical_leaderboard: 'Papan Kedudukan Sejarah',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Jejaki prestasi anda dan lihat kedudukan anda berbanding rakan sebaya',
    time_period: 'Tempoh Masa',
    page_of: 'Halaman 1 daripada 1',
    edit_competition: 'Edit Pertandingan',
    create_competition: 'Cipta Pertandingan',
    arrow_right: 'anak-panah-kanan',
    update_competition: 'Kemas Kini Pertandingan',
    competition_title: 'Tajuk Pertandingan',
    enter_competition_title: 'Masukkan tajuk pertandingan',
    enter_competition_description: 'Masukkan penerangan pertandingan',
    leaderboard_skill: 'Kemahiran',
    select_a_skill: 'Pilih kemahiran',
    no_skills_found: 'Tiada kemahiran ditemui',
    competition_period: 'Tempoh Pertandingan',
    add_badge_rule: 'Tambah Peraturan Lencana',
    create_badge: 'Cipta Lencana',
    add_level_rule: 'Tambah Peraturan Tahap',
    selected_participants: 'Peserta Terpilih',
    no_participants: 'Tiada peserta',
    start_end_date: 'Tarikh Mula–Tamat',
    created_date: 'Dicipta oleh',
    new_competition: 'Pertandingan Baharu',
    competitions_list: 'Senarai Pertandingan',
    search_competitions: 'Cari pertandingan...',
    are_you_sure_you_want_to_delete_the_competition:
      'Adakah anda pasti mahu memadam pertandingan ini',
    history: 'Sejarah',
    export: 'Eksport',
    search_by_name: 'Cari mengikut nama...',
    no_historical_data_available_for_the_selected_period:
      'Tiada data sejarah tersedia untuk tempoh yang dipilih.',
    no_leaderboard_data_available: 'Tiada data papan kedudukan tersedia.',
    competitions: 'Pertandingan',
    leaderboards: 'Papan Kedudukan',
    welcome_back: 'Selamat Kembali',
    track_your_performance_and_see:
      'Jejaki prestasi anda dan lihat kedudukan anda berbanding rakan lain',
    team_leaderboard: 'Papan Kedudukan Pasukan',
    try_again: 'Cuba Lagi',
    no_competitions_for_search: 'Tiada Pertandingan Tersedia untuk',
    no_competitions_available: 'Tiada Pertandingan Tersedia',
    no_competitions_matching_search:
      'Tiada pertandingan dijumpai yang sepadan dengan carian anda. Cuba ubah istilah carian anda atau semak semula kemudian untuk pertandingan baharu.',
    no_competitions_general:
      'Tiada pertandingan disediakan pada masa ini. Sila semak semula kemudian atau hubungi pentadbir anda untuk mencipta pertandingan baharu.',
    media_management: 'Pengurusan Media',
    badgess_set: 'Set Lencana',
    choose_the_default_visual_style_for_badge:
      'Pilih gaya visual lalai untuk ikon lencana yang digunakan di seluruh platform.',
    enable_badges: 'Hidupkan Lencana',
    add_badge: 'Tambah Lencana',
    min: 'Min',
    max: 'Maks',
    your_rank: 'Kedudukan Anda',
    your_points: 'Mata Anda',
    your_level: 'Tahap Anda',
    rank: 'Kedudukan #',
    level: 'Tahap',
    progress: 'Kemajuan',
    new_folder: 'Folder Baharu',
    file_upload: 'Muat Naik Fail',
    writer: 'Penulis',
    text_documents: 'Dokumen Teks',
    spreadsheets: 'Hamparan',
    impress: 'Persembahan',
    presentations: 'Pembentangan',
    capture_desktop_screen: 'Tangkap Skrin Desktop',
    capture_desktop_screens: 'Tangkap skrin desktop',
    your_documents: 'Dokumen Anda',
    manage_your_videos_images_audio_files:
      'Urus video, imej, fail audio, dan aset lain yang digunakan dalam penciptaan kandungan anda.',
    your_organization_documents: 'Dokumen Organisasi Anda',
    keep_your_organization_creative_assets_organized:
      'Pastikan aset kreatif organisasi anda teratur dan mudah diakses—memudahkan kerjasama dan penghasilan kandungan.',
    your_public_documents: 'Dokumen Awam Anda',
    curated_collection_of_media_assets_available:
      'Koleksi terpilih aset media yang tersedia untuk semua—terokai, guna semula, dan cipta.',
    your_download_center_documents: 'Dokumen Pusat Muat Turun Anda',
    repository_of_approved_media_assets_for_download:
      'Repositori aset media yang diluluskan untuk dimuat turun dan digunakan dalam projek anda.',
    search_files_and_folders: 'Cari fail dan folder..',
    home: 'Laman Utama',
    folders: 'Folder',
    folder_name: 'Nama Folder',
    owner: 'Pemilik',
    last_updated: 'Kemas Kini Terakhir',
    action: 'Tindakan',
    no_folders_found: 'Tiada folder ditemui',
    files: 'Fail',
    enabling_ai: 'Mengaktifkan AI...',
    rename: 'Tukar Nama',
    copy: 'Salin',
    move: 'Pindah',
    verson_history: 'Sejarah Versi',
    manage_permission: 'Urus Kebenaran',
    generate_audit_report: 'Jana Laporan Audit',
    last_edited: 'Disunting Terakhir',
    no_files_found: 'Tiada fail ditemui',
    are_you_sure_you_want_to_make_this_item_public:
      'Adakah anda pasti mahu menjadikan item ini awam? Ia akan disalin ke pustaka awam anda.',
    move_to_organization: 'Pindahkan ke Organisasi',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Adakah anda pasti mahu menyalin item ini ke pustaka organisasi anda?',
    are_you_sure_you_want_to_make_this_item_private:
      'Adakah anda pasti mahu menjadikan item ini peribadi? Ia akan disalin ke pustaka anda sendiri.',
    date_modified: 'Tarikh Diubah Suai',
    workflow_management: 'Pengurusan Aliran Kerja',
    configure_editors_approvers_and_viewers_for_this_document:
      'Tetapkan penyunting, pelulus dan penonton untuk dokumen ini.',
    error_Loading_editor: 'Ralat Memuatkan Penyunting',
    debug_info: 'Maklumat Nyahpepijat',
    loading_editor: 'Memuatkan Penyunting...',
    submitted_for_review: 'Dihantar untuk Semakan',
    editors: 'Penyunting',
    no_editors_added_yet:
      'Tiada penyunting ditambah lagi. Klik "Tambah penyunting" untuk menambah seorang.',
    add_editor: 'Tambah Penyunting',
    approvers: 'Pelulus',
    no_approvers_added_yet:
      'Tiada pelulus ditambah lagi. Klik "Tambah pelulus" untuk menambah seorang.',
    add_approvers: 'Tambah Pelulus',
    viewer: 'Penonton',
    no_viewers_added_yet:
      'Tiada penonton ditambah lagi. Klik "Tambah penonton" untuk menambah seorang.',
    add_viewer: 'Tambah Penonton',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Adakah anda pasti mahu memadam item yang dipilih?'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'Gambaran Keseluruhan Kategori',
    triviaReport: 'Kategori ShareSphere',
    overviewGraph: 'Graf Gambaran Keseluruhan Kategori',
    category: 'Kategori',
    phCategory: 'Pilih Kategori',
    podcast: 'Podcast, Muzik dan Cerita',
    pastPodcast: 'Podcast Lepas',
    upcomingPodcast: 'Podcast Akan Datang',
    podcastLanguageTitle: 'Bahasa podcast, muzik & cerita',
    podcastLanguageCheckbox: 'AI jana bahasa untuk podcast saya',
    howRate: 'Bagaimana anda menilai podcast ini?',
    podcastSubmit: 'Hantar',
    podcastGuest: 'Penceramah Tetamu:',
    podcastReview: 'Ulasan',
    podcastEpishode: 'Episod',
    podcastEnd: 'Podcast telah berakhir',
    date_podcast: 'Tarikh Podcast',
    skill_not_found: 'Maaf! Tiada perjalanan kemahiran dijumpai.',
    coaching: 'Latihan',
    webinar: 'Webinar',
    public_conference: 'Persidangan Awam',
    skill_journey_subtitle:
      'Tambah tetapan untuk perjalanan kemahiran anda dan pilih siapa yang boleh melihat dan berinteraksi dengan perjalanan kemahiran anda.',
    enable_white_label: 'Aktifkan label putih',
    create_new_event_org: 'Cipta acara baru untuk organisasi anda.',
    create_new_event_marketplace: 'Cipta acara baru untuk pasaran.',
    create_new_event_both:
      'Cipta acara baru untuk organisasi anda dan pasaran.',
    event_outline: 'Sila Masukkan Garis Besar Acara',
    event_obj: 'Sila Masukkan Objektif Acara',
    event_description: 'Sila Masukkan Penerangan Acara',
    create_new_metamaze_org: 'Cipta MetaMaze baru untuk organisasi anda.',
    create_new_metamaze_marketplace: 'Cipta MetaMaze baru untuk pasaran.',
    create_new_metamaze_both:
      'Cipta MetaMaze baru untuk organisasi dan pasaran.',
    add_key_words: 'Tambah kata kunci',
    press_enter_make_keyword: 'Tekan Enter untuk buat kata kunci',
    disable_skip_quiz: 'Lumpuhkan Langkau Kuiz',
    warning_complete_quiz: 'Sila lengkapkan kuiz untuk meneruskan.',
    signup_email_verification:
      'Kami telah menghantar pautan pengesahan ke alamat yang anda berikan. Sila lawati pautan tersebut untuk mengesahkan pendaftaran anda.',
    verifying_registration: 'Mengesahkan pendaftaran akaun...',
    reset_password_linK:
      'Kami telah menghantar pautan ke alamat yang anda berikan. Sila lawati pautan tersebut untuk menetapkan kata laluan baru.',
    reset_email_error:
      'Pengguna tidak ditemui dengan emel ini, sila cuba lagi menggunakan nama pengguna!',
    first_name: 'Nama Pertama',
    last_name: 'Nama Akhir',
    error_firstName: 'Sila masukkan nama pertama anda',
    error_sharebot_organization: 'Sila masukkan Organisasi anda',
    error_lastName: 'Sila masukkan nama akhir anda',
    private_conference: 'Persidangan Peribadi',
    public_conference: 'Persidangan Awam',
    discussion_room: 'Bilik Perbincangan',
    training_no_courses: 'Anda tidak sedang mengikuti sebarang kursus.',
    training_no_events: 'Anda tidak sedang mengikuti sebarang acara',
    allow_sharing_trainer_info: 'Benarkan perkongsian alamat emel di pasaran',
    error_username_space: 'Nama pengguna tidak boleh ada ruang kosong.',
    error_sharebot_organization_space:
      'Organisasi tidak boleh ada ruang kosong.',
    edit_permission: 'Kebenaran suntingan',
    valid_price: 'Harga mesti lebih besar daripada 0',
    course_price_message: `*kursus akan diterbitkan kepada bilangan pengguna yang dibeli oleh organisasi sahaja dan tidak boleh dijual semula di pasaran`,
    valid_edit_price:
      'Harga untuk suntingan mesti kurang daripada harga untuk beli.',
    my_calendar: 'Kalendar Saya',
    error_valid_firstName: 'Sila masukkan nama pertama yang sah.',
    error_valid_organization: 'Sila masukkan nama Organisasi yang sah.',
    error_valid_lastName: 'Sila masukkan nama akhir yang sah.',
    error_name_spaces: 'Nama tidak boleh ada ruang kosong',
    items: 'Item',
    publish_to_channel: 'Terbitkan ke Koleksi Saluran Saya',
    create_a_channel: 'Cipta Saluran Saya',
    create_a_trivia: 'Permainan Trivia',
    create_a_new_channel: 'Cipta Saluran Baru',
    add_videos: 'Tambah Video',
    save_and_continue: 'Simpan & Teruskan',
    channel: 'Saluran',
    channels: 'Saluran',
    view_channel: 'Lihat Saluran',
    edit_channel: 'Sunting Saluran',
    delete_channel: 'Padam Saluran',
    my_video_channels: 'Saluran Video Saya',
    training_no_channel: 'Anda tidak sedang mengikuti sebarang saluran.',
    monthly_price_required: 'Harga bulanan diperlukan',
    yearly_price_required: 'Harga tahunan diperlukan',
    one_time_price_required: 'Harga sekali bayar diperlukan',
    marketplace_quantity: 'USD',
    report_webinar: 'WEBINAR',
    report_coaching: 'LATIHAN',
    report_channel: 'SALURAN',
    report_public_conference: 'PERSIDANGAN AWAM',
    report_maze: 'LABIRIN',
    channel: 'Saluran',
    edit_price: 'Sunting Harga ($)',
    quantity: 'Kuantiti',
    payment_type: 'Jenis Pembayaran',
    total_amount: 'Jumlah Keseluruhan ($)',
    net_amount: 'Jumlah Bersih ($)',
    edit_option: 'Sunting Pilihan',
    marketplace_price: 'Harga ($)',
    market_name: 'Nama',
    duration_min: 'Tempoh (Min)',
    users_total: 'Pengguna (Jumlah)',
    sales_total: 'Jumlah Jualan (USD)',
    search_coaching: 'Cari Latihan',
    search_channel: 'Cari Saluran',
    search_webinar: 'Cari Webinar',
    search_maze: 'Cari Labirin',
    search_public_conference: 'Cari Persidangan Awam',
    buyer_type: 'Jenis Pembeli',
    quanity: 'Kuantiti',
    channel_unit_amount: 'Jumlah Bersih ($)',
    channel_updated_at: 'Tarikh Kemaskini',
    month_price: 'Harga (Bulan)',
    year_price: 'Harga (Tahun)',
    one_time_price: 'Harga (Sekali Bayar)',
    sharebot_organization: 'Tambah nama organisasi baru',
    share_sphere: 'ShareSphere',
    ai_course_title: 'Tajuk Kursus',
    ai_input_course_title: 'Sila masukkan tajuk kursus!',
    learning_objective_label: 'Objektif Pembelajaran',
    learning_objective_message: 'Sila masukkan objektif pembelajaran!',
    standard_question:
      'Adakah anda mempunyai standard yang perlu diikuti oleh pelajar?',
    standard_details_label: 'Butiran Standard',
    standard_details_message: 'Sila masukkan butiran standard!',
    estimated_duration_label: 'Anggaran Tempoh Kursus (dalam minit)',
    estimated_duration_message: 'Sila masukkan anggaran tempoh!',
    min_duration_message: 'Tempoh minimum adalah 5 minit.',
    ai_mins: '25 minit',
    industry_specific_question: 'Adakah ia khusus industri?',
    industry_label: 'Nyatakan Industri',
    industry_message: 'Sila masukkan industri!',
    ai_course_creation: 'Penciptaan Kursus AI',
    course_generated: 'Kursus Dijana Oleh Sharelook',
    ai: 'AI',
    ai_you: 'Anda',
    ai_prompt_ready:
      'Prompt anda sudah sedia. Anda kini bersedia untuk menjana kandungan.',
    ai_unable_respond:
      'Maaf! AI tidak dapat merespons prompt anda. Sila cuba lagi.',
    ai_hide_toc: 'Sembunyikan Kandungan',
    ai_preview_toc: 'Pratonton Kandungan',
    ai_generate_toc_now: 'Jana Kandungan Sekarang',
    ai_creation_course_title: 'Tajuk Kursus:',
    ai_creation_industry_specific: 'Adakah Ia Khusus Industri:',
    ai_creation_industry: 'Industri:',
    ai_creation_standard_needed:
      'Adakah Anda Mempunyai Standard Yang Perlu Diikuti Oleh Pelajar?:',
    ai_creation_standard_details: 'Butiran Standard:',
    ai_creation_estimated_duration: 'Anggaran Tempoh Kursus (Dalam Minit):',
    minutes: 'minit',
    ai_creation_learning_objective: 'Objektif Pembelajaran:',
    setup_again: 'Tetapkan Semula',
    ai_creation_confirm_title:
      'Adakah anda pasti mahu menetapkan borang semula?',
    ai_creation_confirm_content:
      'Sembang & semua kandungan yang telah anda jana akan ditetapkan semula.',
    ai_toc: 'Kandungan',
    ai_note_topic:
      'Nota: Anda boleh menyeret dan meletakkan untuk menyusun semula topik dalam pelajaran.',
    ai_add_topic: '+ Tambah Topik',
    add_topic: 'Tambah Topik',
    add_lesson: 'Tambah Pelajaran',
    add_new_lesson: 'Tambah Pelajaran Baru',
    ai_add_lesson: '+ Tambah Pelajaran',
    attention: 'Perhatian',
    before_varifying: 'Sebelum Mengesahkan',
    ai_save_later: 'Simpan Untuk Kemudian',
    ai_download_word_doc: 'Muat Turun sebagai Dokumen Word',
    ai_download_course_word_doc: 'Muat Turun Kursus sebagai Dokumen Word',
    ai_create_course_button: 'Cipta Kursus',
    ai_generate_course_content: 'Jana Kandungan Kursus',
    ai_out_of: 'daripada',
    ai_subtopic_failed_content:
      'subtopik gagal menjana kandungan. Klik pada "Jana Kandungan Kursus" lagi untuk menjana kandungan hanya untuk subtopik tersebut.',
    ai_edit_topic: 'Edit Topik',
    ai_edit_lesson_title: 'Edit Tajuk Pelajaran',
    ai_save_topic: 'Simpan Topik',
    ai_save: 'Simpan',
    ai_save_lesson_title: 'Simpan Tajuk Pelajaran',
    ai_add_new_topic: 'Tambah Topik Baru',
    ai_download_ref: 'Muat Turun dengan Rujukan',
    ai_download_ref_content:
      'Ia akan memuat turun kursus sebagai dokumen word dengan rujukan.',
    ai_download_without_ref: 'Muat Turun tanpa Rujukan',
    ai_download_two_word: 'Dua dokumen Word akan dimuat turun:',
    ai_download_two_word_content_one:
      '- satu mengandungi kandungan utama tanpa rujukan,',
    ai_download_two_word_content_two:
      'dan satu lagi terdiri daripada senarai rujukan sahaja tanpa kandungan yang menyertainya.',
    ai_manage_content: 'Urus Kandungan',
    ai_add_content_from_internet: '+Tambah Kandungan Dari Internet',
    ai_confirm_start: 'Sahkan Mula',
    ai_Verify: 'Sahkan',
    ai_undo_warning:
      'Proses ini mungkin mengambil masa. Sila jangan tutup tetingkap ini sehingga penjanaan selesai kerana ia tidak boleh dibatalkan.',
    ai_verified_content:
      'Anda telah mengesahkan kandungan. Perhatikan bahawa selepas pengesahan, anda tidak akan dapat kembali untuk berbual dengan pembantu AI dengan kandungan semasa.',
    ai_want_proceed: 'Adakah anda pasti mahu meneruskan?',
    upload_simulation: 'Muat Naik Simulasi',
    name_simulation: 'Nama Simulasi',
    selected_simulation_files: 'Fail Simulasi Yang Dipilih',
    score_between_one_hundred: 'Skor anda sepatutnya antara 1 dan 100.',
    are_sure_simulation: 'Adakah anda pasti mahu padam fail simulasi ini?',
    required_simulation: 'Skor diperlukan',
    required_section_file: 'Fail bahagian diperlukan',
    simulation: 'Simulasi',
    simulation_quiz_games: 'Perlu menambah kuiz dalam permainan',
    simulation_alert_des:
      'Anda boleh menambah permainan hanya jika semua soalan mempunyai jenis jawapan sama ada tunggal atau berbilang.',
    alert_info: 'maklumat',
    ai_number_quiz: 'Bilangan Kuiz',
    ai_point: 'mata',
    ai_points: 'mata',
    val_required: 'Diperlukan',
    games: 'Permainan',
    add_simulation: 'Tambah Simulasi',
    text_tiewer: 'Paparan Teks',
    back_to_account: 'Kembali ke Akaun',
    delete_account: 'Padam Akaun',
    delete_account_title: 'Padam Akaun ???',
    delete_account_subtitle: 'Anda boleh memadam akaun anda dari sini.',
    delete_account_cannot_undo:
      'Anda akan memadam akaun anda. Tindakan ini tidak boleh dibatalkan.',
    account_org_profile:
      'Anda juga akan kehilangan semua kursus yang telah anda cipta, profil organisasi anda dan semua tetapan anda.',
    deleting_account_database:
      'Memadam akaun anda akan membuang semua data anda dari pangkalan data kami.',
    account_confirm_delete: 'Adakah anda pasti mahu memadam akaun anda?',
    action_cannot_be_undone: 'Tindakan ini tidak boleh dibatalkan.',
    account_delete_message_success: 'Akaun anda telah berjaya dipadam.',
    message_edit: 'Edit',
    message_delete: 'Padam',
    message_reply: 'Balas',
    attached_file: 'Fail Dilampirkan',
    attach_file: 'Lampirkan Fail',
    attach_des: '25 MB, saiz fail maksimum',
    view: 'Lihat',
    go_to_marketplace: 'Pergi Ke Pasaran',
    learning_center: 'Pusat Pembelajaran',
    knowledge_center: 'Pusat Pengetahuan',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Bagaimana saya boleh membantu anda hari ini?',
    my_organization: 'Organisasi Saya',
    world_knowledge: 'Pengetahuan Dunia',
    welcome_to_sharelook: 'Selamat Datang Ke Sharelook !',
    sharelook_you_want_go: 'Ke mana anda mahu pergi hari ini?',
    shareLook_learning_management_system:
      'Akses sistem pengurusan pembelajaran ShareLook untuk mencipta atau mengakses sumber pembelajaran seperti acara langsung dan kursus dalam organisasi anda di ShareLook.',
    shareLook_powerful_ai_system:
      'Akses sistem berkuasa AI ShareLook di mana anda boleh memuat naik dokumen pdf dan mendapat wawasan berguna di hujung jari anda dalam beberapa saat. Dapatkan jawapan pantas berdasarkan sumber yang dimuat naik dalam organisasi anda atau dapatkan jawapan dari sistem AI generik kami di bahagian pengetahuan dunia.',
    edit_now: 'Edit Sekarang',
    sharelook_log_out:
      'Anda telah dilog keluar dari Sharelook. Sila Log Masuk !',
    sorry_error: 'Maaf ! Kami mengalami beberapa ralat.',
    login: 'Log Masuk',
    refresh_page: 'Muat Semula Halaman',
    just_a_moment: 'Sebentar',
    enter_lname_fname:
      'Sila masukkan nama pertama dan nama akhir anda untuk meneruskan.',
    procced_to_sharelook: 'Teruskan ke Sharelook',
    option_one: 'Pilihan 1',
    option_two: 'Pilihan 2',
    selected_image: 'Imej Yang Dipilih:',
    add_text: 'Tambah Teks',
    linkdin_is_required: 'Linkedin diperlukan.',
    bio_is_required: 'Bio diperlukan.',
    save_user_information: 'Simpan Maklumat Pengguna',
    select_all: 'Pilih Semua',
    enable_ai: 'Dayakan AI',
    load_more: 'Muatkan Lagi',
    channel_id: 'ID Saluran.',
    send: 'Hantar',
    v4: 'Maklumat',
    subscription: 'Langganan',
    reset_user_flag: 'TETAPKAN SEMULA BENDERA PENGGUNA',
    delete_my_accont: 'Padam akaun saya',
    sharebot_sub_error: 'Ralat mengambil langganan. Cuba Lagi !',
    sharebot_no_sub: 'Anda kini tidak mempunyai langganan aktif.',
    sharebot_dont_sub: 'Anda tidak mempunyai sebarang langganan sebelumnya.',
    sharebot_prev_sub: 'Dilanggan Sebelum Ini',
    sharebot_sub: 'Langganan ShareBot',
    sharebot_un_sub: 'Batal Langganan ShareBot',
    sharebot_no_available: 'Tiada Penerangan Tersedia',
    sharebot_start_date: 'Tarikh Mula:',
    sharebot_end_date: 'Tarikh Tamat:',
    sharebot_sure: 'Adakah anda pasti?',
    sharebot_do_you_want: 'Adakah anda mahu',
    unsubscribe: 'batal langganan',
    unsubscribe_what: 'batal langganan ?',
    subscribe: 'langgan',
    subscribe_what: 'langgan ?',
    subscribe_now: 'langgan Sekarang',
    confirm: 'Sahkan',
    sharebot_intel_knowledge_center: 'Pusat Pengetahuan Pintar ShareBot',
    sharebot_welcome_paragraph:
      'Selamat datang ke Pusat Pengetahuan ShareBot, chatbot AI canggih yang direka untuk mengubah cara profesional mengakses maklumat dan bekerjasama.',
    expired: 'Tamat tempoh',
    active: 'Aktif',
    Inactive: 'Tidak aktif',
    yearly_subscription: 'Langganan Tahunan',
    monthly_subscription: 'Langganan Bulanan',
    no_sharebot_org: 'Anda tidak mempunyai organisasi sharebot',
    sharebot_start_free_trial: 'Mula Percubaan Percuma',
    sub_month: 'Langganan Bulanan',
    sub_year: 'Langganan Tahunan',
    question_per_month: 'Storan Data (1TB) dan 1000 Soalan sebulan',
    sharebot_para:
      'Dengan meneruskan, anda mengesahkan pemadaman segera organisasi. Tindakan ini akan mengakibatkan kehilangan semua wawasan berharga yang disediakan oleh ShareBot, dan ia tidak boleh dibatalkan.',
    cancelled_date: 'Tarikh Dibatalkan:',
    live_straming_para:
      'Jika anda ingin mengubah had penstriman langsung bulanan anda sila hubungi',
    sharelook_agree: 'Saya bersetuju dengan',
    terms_condition: 'terma & syarat',
    and: 'dan',
    privacy_policy: 'dasar privasi',
    save_for_later: 'Simpan Untuk Kemudian',
    ai: 'AI',
    no_video_yet: 'Tiada Video Dipilih Lagi !',
    are_you_sure_delete_video: 'Adakah anda pasti mahu padam video ini?',
    video_des: 'Penerangan',
    video_now: 'Sekarang',
    video_playing: 'Sedang Dimainkan:',
    video_no: 'Video Bil.',
    ai_generated_course: 'Kursus Dijana AI',
    create_course_on_our_own: 'Cipta Kursus Sendiri',
    ai_Assisted_ourse_reation: 'Penciptaan Kursus Dibantu AI',
    pending: 'Menunggu',
    published: 'Diterbitkan',
    intro_course: 'ke dalam kursus anda?',
    clone_course: 'Adakah anda mahu klon',
    browser_audio_not_support: 'Pelayar anda tidak menyokong tag audio.',
    audio_popup_content:
      'Di mana anda boleh menggunakan banyak gaya suara pada teks yang anda taip bla Bla bla Lorem Ipsum hanyalah teks dummy industri percetakan dan penyusunan huruf. Lorem Ipsum telah menjadi teks dummy standard industri sejak tahun 1500-an,',
    close: 'Tutup',
    podcast_rec: 'REC',
    create_podcast: 'Cipta Podcast',
    add_admin: 'TAMBAH ADMIN',
    delete_all: 'Padam semua',
    ai_podcast_audio: 'Audio Podcast AI',
    language: 'Bahasa',
    podcast_download_content:
      '*Muat turun fail Audio AI untuk penyuntingan untuk menjadi fail audio anda.',
    upload_audio: 'Muat Naik Audio',
    browser_do_not_support_audio: 'Pelayar anda tidak menyokong elemen audio.',
    upload_cover: 'Muat Naik Kulit',
    upload_ai_creator: 'Pencipta AI',
    required_cover_image: 'Imej kulit diperlukan!',
    room_required_name: 'Nama Podcast diperlukan!',
    add_guest_list: 'Sila tambah senarai tetamu!',
    podcast_add_participants: 'TAMBAH PESERTA',
    topic_required: 'Sekurang-kurangnya satu topik diperlukan',
    podcast_description: 'PENERANGAN',
    podcast_date: 'TARIKH',
    date: 'Tarikh',
    podcast_time: 'masa',
    podcast_to: 'kepada',
    podcast_all_day: 'Sepanjang hari',
    podcast_start_date_time: 'Tarikh Mula dan Selang Masa Diperlukan!',
    podcast_id: 'ID',
    selected_user: 'Jemput Pengguna Terpilih',
    see_more: 'Lihat Lagi',
    see_less: 'Lihat Kurang',
    no_review_yet: 'Tiada ulasan lagi, jadilah yang pertama untuk mengulas.',
    request_to_speak: 'Terima permintaan pengguna untuk berucap?',
    kick_user: 'Adakah anda mahu menendang pengguna ini?',
    accept_request: 'Terima Permintaan',
    kick: 'TENDANG',
    started: 'BERMULA',
    end: 'TAMAT',
    join_now: 'Sertai Sekarang',
    podcast_end: 'Podcast telah tamat',
    connecting: 'menyambung...',
    knowledge_center_know_today: 'Apa yang anda ingin tahu hari ini?',
    knowledge_center_question: 'Sila masukkan soalan terlebih dahulu',
    knowledge_center_error: 'Maaf ! Kami mengalami beberapa ralat.',
    knowledge_center_tooltrip:
      'Dapatkan jawapan pantas dari sumber pembelajaran dalam repositori organisasi anda di ShareLook, dengan rujukan yang betul dan kemungkinan untuk pratonton dan muat turun dokumen pdf yang dirujuk.',
    my_organization: 'Organisasi Saya',
    world_knowledge: 'Pengetahuan Dunia',
    open_file: 'Buka Fail',
    reference: 'Rujukan',
    are_you_cancel: 'Adakah anda pasti mahu membatalkan?',
    are_you_remove_media: 'Adakah anda pasti mahu membuang media?',
    terms_agree: 'Saya bersetuju dengan ini',
    ready: 'Sedia',
    send_email: 'HANTAR EMEL',
    active_users: 'Pengguna aktif',
    sign_up_user: 'Pengguna pendaftar',
    non_sign_up_user: 'Pengguna bukan pendaftar',
    organisation: 'Organisasi',
    usage_report: 'Laporan Penggunaan',
    check_email: 'semak emel anda',
    delete_schedule: 'Padam Jadual',
    are_you_sure_delete_schedule: 'Adakah anda pasti mahu padam jadual ini?',
    add_task: 'Sila masukkan tugasan !',
    coaching_available: 'Tandakan sebagai Ketersediaan Jurulatih',
    message_booking_coaching:
      'Slot masa ini ditempah oleh pengguna untuk jurulatih.',
    task_day: 'Hari Tugasan',
    created_task_day: 'Anda telah mencipta tugasan untuk hari ini.',
    event_day: 'Hari Acara',
    has_booked_coaching: 'Jurulatih telah ditempah untuk hari ini.',
    active_day: 'Hari Aktif',
    selectable_time_slots:
      'Slot masa yang boleh dipilih di sebelah kanan aktif untuk hari ini.',
    compare_last_month: 'Berbanding dengan Bulan Lepas',
    uploading_file: 'Memuat naik fail anda',
    attach_file_course: 'dilampirkan pada kursus ini.',
    fetch_request: 'Mengambil permintaan anda',
    finilize_upload: 'Menyelesaikan muat naik',
    scorm_scanned: 'Sila tunggu... SCORM zip yang dimuat naik sedang diimbas.',
    scan_status: 'Status Imbasan:',
    scan_completed: 'Imbasan Selesai. Fail anda adalah',
    scan_progress: 'Imbasan sedang berlangsung...',
    check_scorm: 'Memeriksa format fail SCORM anda... Sila tunggu...',
    file_check_success: 'Pemeriksaan fail berjaya',
    file_check_progress: 'Pemeriksaan fail sedang berlangsung...',
    scorm_not_upload:
      'Fail yang anda muat naik bukan standard SCORM 1.2, Sila muat naik fail lagi.',
    select_question: 'Pilihan Jawapan (pilih satu jawapan yang betul)',
    select_answer: 'Sila pilih pilihan jawapan!',
    check_option_one: 'Sila masukkan pilihan satu!',
    check_option_two: 'Sila masukkan pilihan dua!',
    check_option_three: 'Sila masukkan pilihan tiga!',
    check_option_four: 'Sila masukkan pilihan empat!',
    question_image: 'Imej Soalan',
    select_question_image: 'Sila pilih imej soalan!',
    ans_image: 'Imej Jawapan',
    upload_image_question: 'Muat Naik Imej Jawapan',
    select_image_answer: 'Sila pilih imej jawapan!',
    save_question: 'Simpan Soalan',
    do_you_leave: 'Adakah anda pasti mahu keluar?',
    loose_all_progress: 'Anda akan kehilangan semua kemajuan anda.',
    welcome: 'Selamat Datang',
    team_knowledge_quest: 'Pencarian Pengetahuan Pasukan',
    your_score: 'Skor Anda',
    start_playing: 'Mula Bermain',
    share_sphere_complete: 'ShareSphere Lengkap',
    final_score: 'Skor Akhir',
    play_next: 'Main Seterusnya',
    you_donot_access_event: 'Anda tidak mempunyai akses kepada acara ini.',
    ai_content_generated: 'Kandungan telah dijana untuk topik ini.',
    ai_popup_confirm_content: 'Sahkan Penjanaan Kandungan',
    limit_transcribe_text:
      'Minit Transkripsi Baki: <0>{{ transcribe_limit }}</0> minit <1/><2/> <3>. Untuk menukar had transkripsi anda, sila hubungi </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Anda tidak mempunyai akses ke acara ini.',
    ai_course_title_training: 'Kursus latihan kepimpinan',
    ai_course_object: 'Meneroka Kepimpinan dalam Era Digital',
    create_ai_video: 'Cipta Video AI',
    generate: 'JANA',
    video_generate_process:
      'Proses penjanaan video mungkin mengambil sedikit masa. Anda akan menerima e-mel sebaik sahaja ia selesai.',
    stripe_account_connect:
      'Akaun Stripe anda tidak aktif. Sila sambungkan atau aktifkannya untuk meneruskan.',
    ai_creator: 'Pencipta AI',
    check_video_status: 'Menyemak status penjanaan video...',
    video_on_queue: 'Penjanaan video sedang dalam barisan.',
    video_fail_generation: 'Maaf, penjanaan video gagal. Sila cuba yang lain.',
    video_currently_generated: 'Video ini sedang dijana.',
    checking_status: 'Menyemak Status',
    check_status: 'Semak Status',
    browser_does_not_support_audio: 'Pelayar anda tidak menyokong tag audio',
    existing_edit_scenario:
      'Adakah anda mahu mengedit senario sedia ada atau mencipta senario baharu? Jika anda mencipta senario baharu, senario lama akan hilang.',
    generate_scenario: 'Jana Senario',
    layout: 'Tata Letak',
    confirm_change: 'Sahkan Perubahan',
    generated_ai_creation_message:
      'Sila ambil perhatian bahawa hanya elemen teks yang dijana oleh AI akan dikekalkan. Semua elemen lain akan dipadam daripada halaman.',
    generate_story: 'Jana Cerita',
    save_original_content: 'Simpan kandungan asal:',
    story_added_specified_position:
      'Kedudukan cerita dalam pelajaran. Cerita akan ditambah sebagai blok pada kedudukan yang ditentukan.',
    position_of_story: 'Kedudukan Cerita',
    start_the_lesson: 'Permulaan Pelajaran',
    end_the_lesson: 'Akhir Pelajaran',
    add_story_pages: 'Tambah Cerita ke Halaman',
    browser_does_not_support: 'Pelayar anda tidak menyokong elemen audio.',
    no_video_available: 'Tiada video tersedia.',
    no_podcast_available: 'Tiada podcast tersedia.',
    no_item_baskets: 'Tiada item dalam bakul.',
    ai_course_object: 'Meneroka Kepimpinan dalam Era Digital'
  },
  v2: {
    n_data: 'Tiada Data',
    change: 'Tukar',
    remove: 'Buang',
    auto_background: 'Latar Belakang Auto',
    create_new_course_org: 'Cipta kursus baharu untuk organisasi anda.',
    create_new_course_marketplace: 'Cipta kursus baharu untuk pasaran.',
    create_new_course_both: 'Cipta kursus baharu untuk organisasi dan pasaran.',
    ok: 'Ok',
    page_bg: 'Latar Belakang Halaman',
    lesson_cover: 'Gambar Kulit Pelajaran',
    create_skill_journey: 'Cipta Perjalanan Kemahiran',
    Metamaze: 'Metamaze',
    events: 'Acara',
    scroms: 'SCORM',
    min_score_pass: 'Skor Minimum untuk Lulus',
    no_scorms_available: 'Tiada SCORM tersedia.',
    no_events_available: 'Tiada acara tersedia.',
    no_courses_available: 'Tiada kursus tersedia.',
    no_courses_baskets: 'Tiada kursus dalam bakul.',
    no_mazes_baskets: 'Tiada maze dalam bakul.',
    no_scroms_baskets: 'Tiada SCORM dalam bakul.',
    no_events_baskets: 'Tiada acara dalam bakul.',
    sorry: 'Maaf!',
    option_1: 'Pilihan 1',
    option_2: 'Pilihan 2',
    enter_number_words: 'Masukkan bilangan perkataan maksimum.',
    summarize: 'Ringkaskan',
    answer: 'Jawapan',
    hold_tight_one_minute:
      'Tunggu sebentar! Kami masih bersiap. Ini mungkin mengambil masa sehingga satu minit.',
    enter_question: 'Masukkan soalan anda.',
    enter_relevant_documents: 'Masukkan bilangan dokumen yang berkaitan.',
    please_input_relevant_documents:
      'Sila masukkan bilangan dokumen yang berkaitan!',
    please_wait_loading_results: 'Sila tunggu keputusan dimuatkan...',
    proceed_to_add_voice: 'Teruskan untuk Tambah Suara',
    results: 'Keputusan',
    no_result_found_try_asking_questions:
      'Tiada keputusan ditemui. Cuba tanya soalan lain.',
    eg: 'cth.,',
    what_make_sales_manager:
      'Apa yang boleh menjadikan saya seorang pengurus jualan?',
    please_select_lang: 'Sila pilih bahasa!',
    search: 'Cari',
    please_copy_desired_content:
      'Sila salin kandungan yang dikehendaki dari kotak kiri ke kotak kanan.',
    rating_req: 'Penilaian adalah medan wajib.',
    review_req: 'Ulasan adalah medan wajib.',
    rating_review_req: 'Mesti memberikan penilaian dan ulasan.',
    how_rate_this: 'Bagaimana anda menilai ini?',
    amazing_above_expectations: 'Menakjubkan! Melebihi jangkaan!',
    certificates: 'Sijil',
    you_no_certificates: 'Anda tiada sijil tersedia buat masa ini.',
    please_add_review: 'Sila berikan ulasan bersama penilaian, Terima kasih!',
    post: 'Hantar',
    rate: 'Nilai',
    avg_rating: 'Penilaian Purata',
    no_review_found: 'Tiada Ulasan Ditemui',
    are_sure_to_disale_zoom_integration:
      'Adakah anda pasti mahu nyahaktifkan integrasi Zoom?',
    badges: 'Lencana',
    you_no_badge_available: 'Anda tiada lencana tersedia buat masa ini.',
    download_certificate: 'Muat Turun Sijil',
    loading: 'Memuatkan...',
    no_file_attached: 'Tiada Fail Dilampirkan',
    you_do_not_have_any_notes: 'Anda tiada nota.',
    question: 'Soalan',
    score: 'Skor',
    alert_score_message: 'Orang telah menghantar skor mereka.',
    alert_question_message: 'Tiada soalan ditambah setakat ini.',
    button_submit: 'Hantar',
    button_allScores: 'Semua skor telah dihantar.',
    record_wait: 'Rakaman sedang bermula. Sila tunggu...',
    buttonSubmit_warning: 'Sila isi semua skor sebelum menghantar.',
    upload_ar_assets: 'Muat Naik Aset AR',
    edit_ar_assets: 'Sunting Aset AR',
    edit_maze_assets: 'Sunting Aset MetaMaze',
    upload_assets: 'Muat Naik Aset',
    upload_maze_assets: 'Muat Naik Aset MetaMaze',
    trigger_title: 'Tajuk Pencetus',
    model_title: 'Tajuk Model',
    trigger_description: 'Deskripsi Pencetus',
    model_description: 'Deskripsi Model',
    please_type_target_description: 'Sila taipkan deskripsi sasaran.',
    please_type_model_description: 'Sila taipkan deskripsi model.',
    trigger_image: 'Imej Pencetus*',
    model_image: 'Imej Model*',
    upload_trigger_image: 'Muat Naik Imej Pencetus',
    upload_model_image: 'Muat Naik Imej Model',
    drag_n_drop: 'Seret dan Lepas',
    file_size_should_not_exceed:
      '(Saiz Fail Imej (JPEG) tidak boleh melebihi 512 KB)',
    zip_size_should_not_exceed: '(Saiz Fail ZIP tidak boleh melebihi 60 MB)',
    ar_content: 'Kandungan AR*',
    model_content: 'Model 3D*',
    upload_3d_zip: 'Muat Naik ZIP / Video',
    upload_3d_maze_zip: 'Muat Naik ZIP',
    audio_content: 'Kandungan Audio',
    _mp3: '(.mp3)',
    content_attached: 'ZIP Dilampirkan.',
    video_attached: 'Video Dilampirkan.',
    audio_attached: 'Audio Dilampirkan.',
    enter_trigger_image_title: 'Masukkan tajuk imej pencetus.',
    enter_model_title: 'Masukkan tajuk model MetaMaze.',
    ar_preview_image: 'Imej Pratonton AR',
    upload_preview_image: 'Muat Naik Imej Pratonton',
    upload_audio: 'Muat Naik Audio',
    creating___: 'Sedang Membuat...',
    updating___: 'Sedang Mengemas Kini...',
    create: 'Buat',
    update: 'Kemas Kini',
    ar_assets: 'Imej 3D',
    _3d_files_mp4: '(ZIP .obj, .fbx atau Video .mp4)',
    _3d_files_mp4_ar: '(ZIP .obj, .fbx)',
    maze_3d_files_mp4: '(ZIP .obj, .fbx)',
    _jpg_files: 'Sokongan hanya untuk .jpg',
    persons_have_submitted_their_scores: 'Orang telah menyerahkan skor mereka.',
    no_questions_added_till_now: 'Tiada soalan ditambah sehingga kini.',
    submit: 'Hantar',
    all_scores_submitted: 'Semua skor telah dihantar.',
    recording_is_starting: 'Rakaman sedang bermula. Sila tunggu...',
    please_input_scores_before_submitting:
      'Sila masukkan semua skor sebelum menghantar.',
    end_for_all: 'Tamatkan untuk Semua',
    full_screen: 'Skrin Penuh',
    breakout_room: 'Bilik Pecahan',
    send_invitations: 'Hantar Jemputan',
    add_participants: 'Tambah Peserta',
    create_breakout_room: 'Cipta Bilik Pecahan',
    connecting: 'Menyambung...',
    currently_broadcaster_unavailable: 'Penyiar tidak tersedia sekarang.',
    how_many_breakout_room_to_create:
      'Berapa banyak bilik pecahan yang anda mahu cipta?',
    create_upto_three_breakout_rooms: '*Cipta sehingga 3 Bilik Pecahan',
    allow: 'Benarkan',
    additional: 'Tambahan',
    attachment: 'Lampiran',
    no_description_available: 'Tiada deskripsi tersedia.',
    people: 'ORANG',
    waiting: 'Menunggu',
    hand_raising_users: 'Pengguna Mengangkat Tangan',
    invite: 'Jemput',
    create_room: 'Cipta Bilik',
    create_live_event: 'Cipta Acara Langsung',
    support_upto_fivethousand_participants:
      'Menyokong sehingga 5,000 peserta untuk acara',
    support_upto_ten_participants:
      'Menyokong sehingga 10 peserta video langsung',
    support_upto_twohundred_participants:
      'Menyokong sehingga 200 peserta untuk acara',
    supprt_upto_five_participants:
      'Menyokong sehingga 5 peserta video langsung',
    support_upto_twentyfive_participants:
      'Menyokong sehingga 25 peserta video langsung',
    two_live_video_participants:
      'Terdapat 2 peserta video langsung untuk acara (hos dan hadirin)',
    you_can_have_upto_five_examinees:
      'Anda hanya boleh mempunyai sehingga 5 pemeriksa.',
    you_can_have_upto_twentyfive_participants:
      'Anda hanya boleh mempunyai sehingga 25 peserta.',
    you_can_have_upto_five_participants:
      'Anda hanya boleh mempunyai sehingga 5 peserta.',
    you_can_have_upto_ten_participants:
      'Anda hanya boleh mempunyai sehingga 10 peserta.',
    select_hosts_email: 'Pilih Emel Hos',
    send_invite_email: 'Hantar Emel Jemputan',
    do_not_send_invite_email: 'Jangan Hantar Emel Jemputan',
    error: 'Ralat',
    max_twentyfive_users_allowed: 'Maksimum 25 pengguna dibenarkan memilih',
    max_five_users_allowed: 'Maksimum 5 pengguna dibenarkan memilih',
    max_ten_users_allowed: 'Maksimum 10 pengguna dibenarkan memilih',
    no_user_found: 'Tiada Pengguna Dijumpai',
    transcribe_to: 'Transkrip Kepada',
    integrate_zoom_to_start_meeting:
      'Gabungkan Zoom pada akaun anda untuk memulakan mesyuarat Zoom.',
    zoom_is_not_integrated: 'Zoom tidak digabungkan.',
    delete_poll: 'Padam Undian',
    add_poll: 'Tambah Undian',
    live_now: 'SIARAN LANGSUNG!',
    average_rating: 'Penilaian Purata',
    review: 'Ulasan',
    time_spent: 'Masa Dibelanjakan',
    total: 'Jumlah',
    mins: 'Minit',
    no_data: 'Tiada data untuk kuiz ini.',
    total_score: 'Jumlah Skor',
    pass_score: 'Skor Lulus',
    point: 'Mata',
    wrong: 'Salah',
    response: 'Respons',
    submitted: 'Dihantar',
    average: 'Purata',
    total_play: 'Jumlah Main',
    view_graph: 'Lihat Graf',
    time_spent_mins: 'Masa Dihabiskan (Minit)',
    play: 'Main',
    ideal_path: 'Laluan Ideal',
    user_incorrect_path: 'Laluan Salah Pengguna',
    ideal_path_taken: 'Laluan Ideal Diambil Oleh Pengguna',
    scenario: 'Senario',
    option: 'Pilihan',
    spend: 'Perbelanjaan',
    average_spending_time: 'Purata Masa Perbelanjaan',
    activity_overview: 'Gambaran Aktiviti',
    live_event: 'Acara Langsung',
    live_assessment: 'Penilaian Langsung',
    report_download: 'Muat Turun Laporan',
    all_workshops: 'Semua Bengkel',
    overview_average_activity: 'Gambaran Purata Aktiviti',
    overview_workshop_graph: 'Graf Bengkel Gambaran',
    mazes: 'Labirin',
    correct_feedback: 'Maklum Balas Betul',
    incorrect_feedback: 'Maklum Balas Salah',
    checkin_checkout: 'Daftar Masuk - Daftar Keluar',
    minutes: 'Minit',
    incorrect_path: 'Laluan Salah',
    answer_not_available: 'Jawapan Tidak Tersedia',
    views: 'Tontonan',
    item: 'Item',
    questions: 'Soalan',
    total_points: 'Jumlah Mata',
    total_attempts: 'Jumlah Percubaan',
    created_date: 'Tarikh Dicipta',
    host_name: 'Nama Hos',
    host_section: 'Bahagian Hos',
    choose_products: 'Pilih Produk',
    add_to_basket: 'Tambah ke Bakul',
    basket: 'Bakul',
    times: 'Kali',
    scorms: 'SCORMs',
    skill_journey_overview: 'Gambaran Perjalanan Kemahiran',
    how_to_use: 'Cara Menggunakan',
    live_broadcast_description:
      'KAMI TELAH MENGINTEGRASIKAN VIDEO LANGSUNG KE DALAM PEMBINA KURSUS YANG MUDAH DIGUNAKAN',
    live_broadcast_subdescription:
      'Dengan sistem siaran langsung ShareLook yang dipatenkan, anda boleh mencipta penglibatan, mengautomasikan pembelajaran, dan memaksimumkan perkongsian pengetahuan.',
    disclaimer: `Saya menjamin bahawa perjalanan kemahiran saya tidak akan: 
  - melanggar hak mana-mana pihak ketiga
  - mengandungi sebarang perkara yang menyalahi undang-undang, termasuk fitnah, lucah, tidak sopan, cabul, pornografi, keganasan, penyalahgunaan, penghinaan, ancaman, atau kandungan diskriminasi, walaupun disamarkan dengan tanda asterisk
  - mengandungi serangan peribadi terhadap orang lain
  - menyamar sebagai peserta lain, tokoh awam atau selebriti
  - mengandungi sebarang rakaman atau maklumat peribadi mengenai mana-mana individu tanpa kebenaran individu tersebut dan tidak melanggar mana-mana peraturan perlindungan data di mana-mana bahagian dunia
  - mengandungi sebarang permohonan komersial atau sebarang bentuk "spam"`,
    price: 'Harga',
    video_link: 'Pautan Video',
    category: 'Kategori',
    objectives: 'Objektif',
    marketplace_description: 'Penerangan Marketplace',

    live_discussion: 'PERBINCANGAN LANGSUNG',
    poll: 'TINJAUAN',
    hide_grid: 'Sembunyikan Grid',
    show_grid: 'Tunjukkan Grid',
    stop_screen_share: 'Hentikan Kongsi Skrin',
    screen_share: 'Kongsi Skrin',
    mute: 'Bisukan',
    unmute: 'Nyahbisukan',
    raise_hand: 'Angkat Tangan',
    waiting__: 'Menunggu...',
    audio_active: 'Audio Aktif'
  },
  general: {
    save: 'บันทึก',
    autosaved: 'บันทึกอัตโนมัติ',
    back_to: 'กลับไปยัง',
    by: 'โดย',
    chat: 'การพูดคุย',
    completed: 'เสร็จ',
    canceled: 'Dibatalkan',
    component: 'Komponen',
    confirm: 'Sahkan',
    course: 'Kursus',
    skill: 'Perjalanan Kemahiran',
    maze: 'MetaMaze',
    channel: 'Saluran',
    podcast: 'Podcast',

    date: 'Tarikh',
    details: 'Butiran',
    empty: 'Tiada data',
    enrolled: 'Didaftarkan',
    free: 'Percuma',
    graph: 'Graf',
    loading: 'Sedang Dimuatkan...',
    lesson: 'pelajaran',
    lessons: 'pelajaran',
    live_assessment: 'Penilaian Secara Langsung',
    live_event: 'Acara Langsung',
    no: 'TIdak',
    of: 'Dari',
    or: 'Atau',
    organization: 'Organisasi',
    page: 'Halaman',
    pages: 'Halaman',
    personal: 'Peribadi',
    poll: 'Undian',
    rating: 'Penarafan',
    reset: 'Set Semula',
    signin: 'Log Masuk',
    signup: 'Daftar',
    soon: 'Sebentar lagi',
    type: 'Jenis',
    uploading: 'Memuat naik...',
    yes: 'Ya',
    something_went_wrong: 'Ada kesalahan!',
    view_all: 'Lihat Semua',
    upload_successful: 'Berjaya Muat Naik',
    upload_successful_message:
      'Dokumen excel anda berjaya dimuat dan sedang diproses. Ini memerlukan sedikit masa untuk selesai.',
    check_email_upload_successful:
      'Sila <0>semak e-mel anda</0> untuk <1>laporan</1> senarai pengguna yang telah dimuat naik.',
    is_private: 'Privasi'
  },

  account: {
    title: 'Akaun',
    subtitle: 'Mengendali seting dan maklumat akaun anda.',
    saved: 'Perubahan Akaun berjaya'
  },

  assessments: {
    title: 'Pernilaian',
    subtitle: 'Cipta Penilaian',
    finished: 'Penilaian sudah selesai',
    countdown: 'Penilaian secara langsung akan disiarkan dalam ',
    create: 'Cipta Penilaian',
    list_title: 'Penilaian Anda',
    delete_warning: 'Adakah anda pasti mahu memadamkan Item ini?',
    details_title: 'Tambah Butiran Penilaian',
    details_subtitle:
      'Namakan Penilaian anda dan beritahu penonton anda apa yang mereka dijangka akan belajar.',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh, pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang perkara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”`
  },

  buildersettings: {
    title: 'Terbitkan Seting',
    subtitle:
      'Tambahkan seting ke acara anda, tentukan siapa yang boleh menonton dan berinteraksi dengan acara anda'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Tambah',
    add_page: 'Tambah halaman',
    add_lesson: 'Tambah ajaran',
    add_answer: 'Tambahkan jawapan baru',
    add_group: 'Tambah Kumpulan',
    add_organization: 'Tambah Organisasi',
    add_question: 'Tambah soalan',
    add_quiz: 'Tambah Kuiz',
    add_users: 'Tambah Pengguna',
    back: 'Kembali',
    back_to_course: 'Kembali ke Rumusan Kursus',
    back_to_lesson: 'Kembali ke Rumusan Pelajaran',
    back_to_media: 'Kembali ke Simpanan Media',
    back_to_details: 'Kembali ke butiran',
    cancel: 'Batal',
    clear: 'Kosongkan',
    close: 'Tutup',
    clone: 'Klon',
    close_lesson: 'Tutup Ajaran',
    clone_course: 'Klon Kursus',
    confirm: 'Sahkan',
    create: 'Cipta',
    download: 'Muat turun',
    download_mass_user_tamplate: 'Muat turun Templat',
    add_mass_users: 'Tambah Banyak Pengguna',
    upload_excel_list: 'Muat naik Senarai Excel',
    delete: 'Padamkan Media',
    edit: 'Edit',
    edit_course: 'Edit Kursus',
    enroll: 'Daftar',
    finish: 'Tamat',
    upload_image: 'Muat naik gambar',
    upload_image_video: 'Muat naik gambar atau video',
    select_media_library: 'Pilih simpanan media',
    make_public: 'Jadi Terbuka',
    make_private: 'Jadi Peribadi',
    make_org: 'Jadi Organisasi',
    media: 'Simpanan Media',
    my_theme: 'Tema Saya',
    next: 'Seterus',
    next_lesson: 'Ajaran Seterusnya',
    next_step: 'Langkah Seterusnya',
    previous_step: 'Langkah sebelumnya',
    publish: 'Terbit',
    publish_assessment: 'Terbitkan penilaian anda',
    publish_course: 'Terbitkan kursus anda',
    publish_event: 'Terbitkan acara anda',
    reset: 'Set Semula',
    reset_elements: 'Set Semula Elemen',
    save: 'Simpan',
    creating: 'Sedang Cipta...',
    updating: 'Sedang Kemas kini...',
    saved: 'Sudah Simpan',
    save_for_later: 'Simpan untuk nanti',
    save_settings: 'Simpan Seting',
    select_files: 'Pilih Fail',
    select_theme: 'Pilih Tema',
    start_lesson: 'Mulakan Pelajaran',
    update: 'Kemas kini',
    upload: 'Memuat Naik',
    upload_audio: 'Muat naik Audio',
    upload_photo: 'Muat naik gambar profil',
    upload_video: 'Muat Naik Video',
    enrolled: 'Sudah Daftar',
    unenroll: 'Daftar di bantal',
    from_library: 'Simpanan Media',
    remove: 'Padam',
    removed: 'Sudah Dipadam',
    start_broadcast: 'Mulakan Siaran',
    end_broadcast: 'Tamatkan Siaran',
    camera: 'Kamera',
    screen: 'Skrin',
    screen_with_camera: 'Skrin dengan Kamera'
  },

  card: {
    quick_add: 'Tambah Ringkas',
    add: 'Tambah',
    clone: 'Klon',
    completed: 'Pelajaran Selesai'
  },

  course: {
    upcoming_course: 'Kursus Akan Datang',
    unPublishEvent: 'Nyahterbitkan Acara',
    unPublishAssessment: 'Nyahterbitkan Penilaian',
    pastCourse: 'Latihan Kursus',
    upcoming: 'Acara Langsung Akan Datang',
    pastEvent: 'Acara Yang Lalu',
    pastAssessment: 'Penilaian yang lalu',
    upcomingAssessment: 'Penilaian Akan Datang',
    created: 'Tarikh Ditetap:',
    assignees: 'Wakil',
    organisations:
      ' {{ organisasi }} Organisasi, <2> {{ pengguna }} pengguna</2>',
    event_date: 'Tarikh acara langsung <1> {{ tarikh }} </1>',
    delete_warning: 'Adakah anda pasti mahu padam',
    clonning_no_lesson:
      'Sila tambah sekurang-kurangnya satu ajaran untuk klon kursus ini.',
    clone_warning: 'Adakah anda pasti mahu klon ini',
    clone_success: 'Klon sedang diproses',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh, pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang pekara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”`
  },

  coursecreate: {
    dropzone_text: 'Masukkan Medica',
    sidebar_text: 'Pilih Satu Tema <1/> untuk <3/> Pelajaran Anda',
    delete_warning: 'Adakah anda pasti mahu memadamkan pelajaran ini?'
  },

  coursepage: {
    quizview_loading: 'Sedang semak jawapan. Sila tunggu...',
    quizview_answer: 'Jawapan Anda'
  },

  coursequiz: {
    title: 'Kuiz dalam semua Pelajaran'
  },

  dashboard: {
    tooltip_title: 'Jangan papar video ini lagi',
    page_title: 'Statistik Kursus Anda',
    page_subtitle: 'Status kursus anda',
    profile_add_info:
      'Tambah <1>{{Tekstidaklengkap}}</1> untuk melengkapkan profil anda.',
    profile_build:
      'Bina profil anda <1>sini</1>, beritahu kami minat dan kemahiran anda.',
    profile_title: 'Pelindungan Profil',
    more_details: 'Maklumat lanjut'
  },

  errors: {
    answer: 'Sila masukkan jawapan',
    answer_correct: 'Pilih jawapan yang betul',
    code: 'Sila masukkan kod anda',
    criterion: 'Sila masukkan kriteria',
    duration: 'Tempoh masa perlu diisi',
    element: 'Sila masukkan element',
    email: 'Sila masukkan e-mel anda',
    email_invalid: 'E-mel tidak sah',
    feedback_correct: 'Sila beri maklum balas, betul ',
    feedback_incorrect: 'Sila beri maklum balas, salah',
    host: 'Sila masukkan hos acara',
    host_assessment: 'Sila masukkan hos penilaian',
    image: 'Sila muat naik gambar',
    location: 'Sila masuk lokasi anda',
    live_location: 'Sila pilih lokasi siaran',
    limit: 'Sila masuk tempoh masa dalam minit untuk strim langsung anda',
    min_3char: 'Minimum 3 aksara',
    number: 'sila masuk nombor positif.',
    host_email_require: `E-mel hos diperlukan.`,
    attendee_email_require: `E-mel peserta diperlukan.`,
    name: 'Sila masukkan nama anda',
    not_found_course: 'Kursus tidak dijumpai',
    not_found_event: 'Acara tidak dijumpai',
    not_found_assessment: 'Penilaian tidak dijumpai',
    password: 'Sila masukkan kata laluan anda',
    password_digit: 'Minimum satu nombor digit diperlukan',
    password_short: 'Kata laluan terlalu pendek, perlukan minimum 10 aksara',
    password_special: 'Minimum satu aksara khas',
    password_uppercase: 'Minimum satu huruf besar',
    password_lowercase: 'Minimum satu huruf kecil',
    phone: 'Sila masukkan telefon anda',
    phone_invalid: 'Nombor telefon tidak sah',
    position: 'Sila masukkan posisi anda',
    question: 'Sila masukkan soalan',
    start_date: 'Tarikh & Waktu Permulaan diperlukan',
    tag: 'Sila pilih satu teg',
    topics: 'Sila pilih minimum satu topik.',
    live_topics: 'Sila tambah topik',
    title: 'Sila masukkan tajuk',
    title_assessment: 'Sila masukkan tajuk penilaian',
    title_course: 'Sila masukkan tajuk kursus',
    title_empty: 'Tajuk tidak boleh kosong',
    title_event: 'Sila masukkan tajuk acara',
    title_lesson: 'Sila masukkan tajuk pelajaran',
    title_quiz: 'Sila masukkan nama kuiz',
    username: 'Sila masukkan nama pengguna anda',
    upload_error: 'Ralat - Fail tidak sesuai!',
    upload_more_than_10:
      'Anda hanya boleh memuat naik maksimum 10 fail setiap kali.',
    topics_max: 'Sila tambah maksimum 3 topik.',
    upload_excel: 'Sila pastikan anda telah memuat naik fail yang betul.',
    title_excel: 'Ralat ketika memuat naik templat:',
    file_size_exceed: 'Saiz fail terlalu besar',
    subtitle_excel:
      'Pastikan anda menggunakan templat yang disediakan dan isi dalam ruang dengan maklumat yang betul.',
    select_broadcast_option: 'Sila tentukan pilihan untuk siaran acara',
    multi_hosts_number_error:
      'Bilangan penyampai tidak boleh melebihi bilangan yang ditentukan untuk acara.',
    conference_people_number_error: `Bilangan penonton tidak boleh melebihi bilangan yang ditentukan untuk acara.`,
    select_max_host: 'Pilih minimum 1 penyampai untuk acara.',
    select_max_conference: 'Pilih minimum 1 penonton untuk acara.',
    stream_stop_error: 'Ralat, Strim Ditamatkan!',
    unsecure_context:
      'Ralat Fatal: Pelayar tidak dapat mengakses kamera dan mikrofon kerana konteks yang tidak selamat. Sila pasangkan SSL and akses melalui https',
    ws_not_supported: 'Ralat Fatal:WebSocket tidak disokong oleh pelayar ini'
  },

  events: {
    title: 'Tambahkan Butiran Acara Langsung',
    change_host: 'Tukar Hos',
    finished: 'Acara dah tamat',
    countdown: 'Acara langsung akan disiarkan dalam ',
    subtitle:
      'Namakan acara anda dan beritahu penonton anda apa yang mereka dijangka akan belajar.',
    poll_disabled: 'Undian tidak tersedia dalam acara ini',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh,  pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang perkara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”'`,
    prompt_message:
      'Keluar dari halaman ini akan tamatkan acara anda. Adakah anda pasti nak keluar dari halaman ini?',
    duration_exceed_message:
      'Masa siaran anda melebihi had yang ditetapkan, aplikasi akan hentikan penyiaran.',
    before_schedule_message:
      'Anda akan memulakan siaran sebelum waktu acara yang dijadualkan. Harap maklum bahawa jika anda menghentikan siaran, acara akan ditamatkan.',
    browser_unsupportive_message:
      'Pelayar anda tidak menyokong Screen Share. Anda akan dapat cari pelayar yang disokong melalui pautan ini ',
    cancel_switch_host_message:
      'Hos tidak tersedia. Acara ini akan disambung dari sambungan anda.',
    coaching_prompt_message:
      'Anda tidak boleh keluar dari halaman ini sehingga acara ditamatkan.',
    event_modal_warn: 'Anda mahu tamatkan acara ini?',
    confirm_message: 'Acara anda akan tamat jika anda klik OK.',
    screen_share_denied: 'Anda menolak untuk mempamerkan skrin anda',
    media_not_found:
      'Kamera atau Mikrofon tidak dapat dijumpai atau tidak dibenarkan di peranti anda.',
    media_not_access:
      'Kamera atau Mic digunakan oleh proses yang lain yang tidak memberi akses kepada peranti',
    constraint_error:
      'Tidak ada peranti yang sesuai dengan kekangan video dan audio anda. Anda boleh mengubah kekangan video dan audio',
    media_access_denied: 'Anda tidak dibenar untuk akses kamera dan mikrofon.'
  },

  filters: {
    days7: '7 hari yang lalu',
    days15: '15 hari yang lalu',
    days30: '30 hari yang lalu',
    days365: '365 hari yang lalu',
    date: 'Tarikh dicipta',
    relevance: 'Relevansi',
    popularity: 'Populariti',
    name: 'Nama',
    group: 'Kumpulan',
    Newest_to_Oldest: 'Terbaru Hingga Terlama',
    Oldest_to_Newest: 'Terlama Hingga Terbaru',
    A_Z: 'A ke Z',
    Z_A: 'Z ke A'
  },

  helpers: {
    password:
      'Untuk melindungi keselamatan akaun anda, kami memerlukan minimum satu huruf kecil, nombor dalam kata laluan anda. Panjang kata laluan juga perlu mempunyai minimum 10 aksara. ',
    phone: 'Sila masukkan kod telefon negara anda, contoh: +65',
    username:
      'Nama pengguna anda diguna sebagai maklumat awam dan akan dikongsikan dengan pengguna lain mengikut keperluan. Oleh itu, kami cadangkan agar anda tidak bubuh maklumat peribadi dalam nama pengguna anda',
    public_description_normal:
      '<0><0/></0> anda telah disimpan dan dikelaskan peribadi secara lalai. Ini bermakna hanya anda yang boleh akses kandungan ini. Untuk menerbitkan kandungan ini, anda boleh memilih salah satu pilihan di bawah. Menerbitkan kursus anda menjadi Terbuka bermaksud bahawa ia akan tersedia dan dilihat oleh semua pengguna di platform. Pilihan Untuk Pengguna Khusus sahaja akan membolehkan anda berkongsi kursus anda dengan pengguna tertentu menggunakan alamat e-mel yang paut dengan akaun Sharelook mereka.',
    public_description_admin:
      '<0><0/></0> telah disimpan dan dikelaskan peribadi secara lalai. Ini bermaksud bahawa hanya anda (dan pencipta kandungan) dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh memilih salah satu pilihan di bawah. Menerbitkan kursus anda menjadi Terbuka bermaksud bahawa ia akan tersedia untuk semua pengguna di platform - termasuk mereka yang berada di luar organisasi anda. Menerbit ke organisasi bermaksud semua pengguna dalam organisasi akan dapat melihatnya. Anda juga boleh menerbitkannya kepada lebih dari 1 kumpulan, yang bermaksud hanya pengguna dalam kumpulan tersebut yang dapat melihatnya. Akhirnya, anda mempunyai pilihan untuk menerbit kepada pengguna tertentu di dalam dan di luar organisasi anda menggunakan alamat e-mel akaun Sharelook mereka.'
  },

  labels: {
    add: 'Tambah',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Jenis Jawapan',
    answers: 'Jawapan',
    back_to_quiz: 'Balik ke senarai Kuiz',
    back_to_question: 'Balik ke senarai soalan',
    chat: 'Sembang',
    chat_available: 'kotak Sembang tidak tersedia dalam acara ini',
    chat_report: 'Laporan Sembang',
    choice_single: 'Pilihan tunggal',
    choice_multiple: 'Pelbagai pilihan',
    choice_free: 'Pilihan"Bebas',
    choice_sorting: 'Pilihan"Pengisihan',
    choice_matrix: 'Pilihan"Pengisihan Matrix',
    clone_lesson_permission: 'Kebenaran Klon',
    code: 'Kod',
    correct: 'Betul',
    created: 'Tarikh Dicipta',
    clone_modal: 'Klon Kursus',
    cloning_course: 'Kursus Sedang Diklon...',
    cloning: 'Sedang Klon...',
    cloning_course_desc: 'Proses ini akan memakan sikit masa. Sila bersabar',
    cloning_success: 'Kursus "<0/>" telah berjaya diklon!',
    description: 'Penerangan',
    disclaimer: 'Notis Penafian',
    drop_file: 'Letak fail di sini...',
    duration: 'Tempoh',
    edit: 'Edit',
    email: 'E-mel',
    event: 'Acara',
    event_all: 'Semua Acara',
    event_date: 'Tarikh / Waktu Tempatan Acara Langsung',
    event_this: 'Acara ini',
    expire: 'Tamat pada',
    expiry_date: 'Tarikh Luput',
    forgot: 'Terlupa Kata Laluan?',
    group: 'Kumpulan',
    groups_list: 'Senarai Kumpulan',
    host: 'Hos',
    id_annotation: 'Identiti anotasi',
    id_quiz: 'Identiti Kuiz',
    incorrect: 'Salah',
    interests: 'Minat',
    invited: 'Dijemput',
    live_chat: 'Perbincangan Secara Langsung',
    live_stream_limit: 'Tempoh Minit Strim',
    contact_text: 'Untuk menukar had tempoh strim bulanan anda, sila hubungi',
    contact_admin:
      '<0>Jika anda ingin tukar had tempoh strim bulanan anda, sila hubungi</0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Baki Tempoh Strim Dalam Minit: <0>{{ had }}</0> minit <1/><2/> <3>Untuk menukar had tempoh strim bulanan anda, sila hubungi</3> <4>admin@sharelook.com</4>',
    location: 'Lokasi',
    lessons: 'Ajaran',
    location_broadcast: 'Lokasi Peservis Hos',
    location_broadcast_subtitle:
      'Masukkan lokasi yang paling dekat dengan lokasi Hos siaran untuk mengurangkan kelewatan audiol',
    media_manager: 'Pengurus Media',
    minutes: 'Minit',
    name: 'Nama',
    online_quiz: 'Kuiz Dalam Talian',
    organiser: 'Pencipta',
    organization: 'Organisasi',
    overall_emotion: 'Pengalaman keseluruhan:',
    organizations_list: 'Senarai Organisasi',
    password: 'Kata Laluan',
    participants: 'Peserta',
    picture: 'Gambaran (16:9)',
    phone: 'Telefon',
    photo: 'Telefon',
    poll: 'Undian',
    position: 'Posisi',
    processing: 'Sedang diproses',
    privacy_settings: 'Seting Privasi',
    question: 'Soalan',
    quiz_create: 'Cipta Kuiz Baru',
    quiz_name: 'Nama Kuiz',
    quiz_update: 'Kemas kini Kuiz',
    select_organization: 'Pilih satu organisasi',
    settings: 'Seting',
    show: 'Papar',
    show_graph: 'Paparkan keputusan graf',
    signin: 'Log Masuk',
    signup: 'Daftar',
    sort_by: 'Susun ikut',
    start_date: 'Tarikh Permulaan',
    tags: 'Teg',
    terms: 'Saya bersetuju dengan <1>terma dan syarat ini</1>.',
    title: 'Tajuk',
    topics: 'Topik',
    topic: 'Topik',
    total_comments: 'Jumlah Komen',
    username: 'Nama Pengguna',
    users_list: 'Senarai Pengguna',
    users_emails: 'Masukkan e-mel pengguna yang ditetapkan',
    description_specifiction_email:
      'Sila hanya masukkan 1 alamat e-mel untuk setiap baris untuk berkongsi dengan beberapa pengguna yang ditetapkan.',
    message_specific_email: 'Sila masukkan e-mel pengguna yang ditetapkan.',
    viewers: 'Penonton',
    edit_course: 'Edit',
    edit_assessment: 'Edit',
    edit_event: 'Edit',
    delete_course: 'Padam',
    delete_event: 'Padam',
    delete_assessment: 'Padam',
    view_course: 'Tonton',
    view_event: 'Tonton',
    view_assessment: 'Tonton',
    date_event: 'Tarikh Acara Langsung',
    date_assessment: 'Tarikh Penilaian',
    clone_of: 'Klon',
    clone_course:
      'Klon kursus ini yang membenarkan anda untuk membuat perubahan secara bebas, termasuk semua pelajaran dan halaman.',
    make: 'Buat',
    available_to: 'tersedia untuk mana-mana pengguna ShareLook',
    uploaded_by: 'Dimuat naik oleh: ',
    course: 'Kursus',
    assessment: 'Penilaian',
    user_not_exist:
      'Pengguna tidak wujud, anda masih ingin menghantar jemputan?',
    check_user: 'Notis',
    user_not_exist_in_org:
      'Pengguna ini tidak wujud dalam organisasi ini, anda masih ingin menghantar jemputan?',
    title_modal_stream: 'Tukar Had Strim Organisasi',
    des_warning_stream: 'Anda akan Tukar',
    monthly_stream: 'had strim bulanan:',
    min_per_month: 'minit/bulan',
    broadcast_label: 'Saya nak:',
    hosts_emails: `Masukkan e-mel hos`,
    attendee_emails: `Masukkan e-mel peserta`,
    description_host_specifiction_email:
      'Sila hanya isi 1 alamat e-mel untuk setiap baris.',
    presenter_label: 'Penyampai',
    presenter_label_conference: 'Bilangan Orang',
    event_privacy: 'Mod Persidangan'
  },

  broadcastOptions: {
    stream_from_phone: 'Siaran Langsung dari telefon saya',
    other_webrtc: 'Persidangan web dari komputer saya',
    multihost: 'Persidangan web Multicast dari komputer saya',
    peer2peer: 'Sesi Bimbingan',
    conference: 'Konferensi Secara Langsung'
  },

  lessoncreate: {
    title: 'Tambah butiran pelajaran',
    subtitle:
      'Namakan ajaran anda dan beritahu penonton anda apa yang mereka dijangka akan belajar.',
    input_label_title: 'Tajuk Pelajaran',
    input_label_topics: 'Topik Pelajaran',
    input_label_description: 'Penerangan Pelajaran',
    delete_warning: 'Adakah anda pasti mahu memadam halaman ini?'
  },

  lessonoverview: {
    title: 'Tambah Pelajaran',
    subtitle: 'Tambah pelajaran yang sedia ada atau cipta yang baru',
    new_lesson: 'Cipta pelajaran baru',
    new_lesson_sub: 'Cipta pelajaran baru dari awal!',
    existing_lesson: 'Pilih pelajaran yang sedia ada',
    existing_lesson_sub:
      'Sambung ke pelajaran yang sedia ada, perubahan yang dibuat kepada pelajaran ini juga akan mempengaruhi pelajaran ini di kursus lain.',
    clone_lesson: 'Membuat salinan pada pelajaran sedia ada',
    clone_lesson_sub:
      'Buat salinan unik untuk pelajaran dalam kursus ini, perubahan yang dibuat pada pelajaran ini tidak akan tukar pelajaran asalnya.',
    clone_lesson_modal_sub:
      'Sila klik butang klon di bawah pelajaran yang anda ingin masukkan ke kursus anda.'
  },

  management: {
    groups_title: 'Mengendali Kumpulan',
    delete_warning: 'Adakah anda pasti?',
    organizations_title: 'Organisasi Saya',
    organizations_subtitle: 'Tambah organisasi ke senarai anda',
    users_title: 'Mengendali Pengguna',
    users_position: 'Pengurus Kanan Akaun',
    user_not_found: 'Pengguna tidak dapat dijumpai',
    select_org:
      'Sila cari dan pilih satu organisasi untuk menguruskan akaun pengguna'
  },

  audio: {
    modal_title: 'Masukkan Audio',
    list_view: 'Paparan Senarai',
    create_audio_modal_title: 'Cipta Audio',
    edit_audio_modal_title: 'Edit Audio',
    public_audio_not_found: 'Audio tidak dapat dijumpai.',
    private_audio_not_found: 'Anda masih belum memuat naik audio',
    are_you_sure_to_delete: 'Adakah anda pasti untuk memadam?',
    type_something: 'Tulis sesuatu',
    select_voice: 'Pilih',
    file_name: 'Nama Fail',
    description: 'Penerangan',
    topic: 'Topik',
    key_words_tag: 'Kata kunci Teg',
    mp3_audio: 'Audio MP3',
    created: 'Sudah Dicipta',
    duration: 'Tempoh',
    close: 'tutup'
  },

  image: {
    modal_title: 'Masukkan Imej',
    image: 'Imej',
    pixel: 'Pixel',
    dimension: 'Dimension',
    public_image_not_found: 'Image not found.',
    private_image_not_found: 'Anda masih belum memuat naik gambar'
  },

  annotation: {
    modal_title: 'Anotasi'
  },

  text: {
    modal_title: 'Penyunting Teks'
  },

  video: {
    modal_title: 'Masukkan Video',
    image: 'Video',
    mp4_video: 'MP4 Video',
    public_video_not_found: 'Video tidak dapat dicari.',
    private_video_not_found: 'Anda masih belum memuat naik video'
  },

  media: {
    title: 'Simpanan Media',
    subtitle: 'Simpanan Fail Anda',
    modal_title: 'Memuat naik media',
    delete_warning: 'Sah memadam',
    delete_message:
      'Media yang dipadam masih akan wujud di halaman yang mereka digunakan ',
    dropzone_text: 'atau Seret dan Lepas',
    delete_success: 'Media telah berjaya dipadam',
    upload_file: 'Memuat naik fail',
    drag_drop: 'atau Seret dan Lepas',
    import_file: 'Import fail dari komputer anda',
    no_media: 'Anda masih belum memuat naik media',
    media_type: 'Jenis Media',
    video: 'Video',
    image: 'Imej',
    audio: 'Audio',
    transcribed_text: 'Transcribed Text',
    gif: 'GIF',
    media_not_found: 'Media tidak dapat dicari.',
    of: 'of',
    disclaimer: `Saya menjamin bahawa penilaian saya yang dicatat tidak akan:
    - melanggar hak mana-mana pihak ketiga
    - mengandungi sebarang unsur yang haram, termasuk fitnah, cabul, tidak senonoh,  pornografi, keganasan, kekasaran, hina, ancam, atau diskriminasi kandungan, ataupun menyamar dengan asterisk
    - mengandungi sebarang unsur serangan peribadi terhadap orang lain
    - mengandungi penyamaran peserta lain, tokoh awam ataupun selebriti
    - mengandungi sebarang perkara atau maklumat peribadi mana-mana individu tanpa persetujuan individu tersebut dan tidak melanggar peraturan perlindungan data di mana-mana tempat di dunia ini
    - mengandungi sebarang kutipan komersial atau sebarang bentuk "spam”'`
  },

  navigation: {
    account: 'Akaun',
    assessments: 'Penilaian',
    dashboard: 'Papan Pemuka',
    groups: 'Pengendalian Kumpulan',
    logout: 'Log Keluar',
    organisations: 'Organisasi',
    organizations_users: 'Organisasi dan Pengguna',
    reports: 'Laporan',
    schedule: 'Jadual',
    training: 'Latihan',
    nowLive: 'Bersiaran',
    users: 'Pengguna',
    workshop: 'Bengkel Saya'
  },

  onboarding: {
    step1_title: 'Langkah 1: Beritahu Kami Serba Sedikit Tentang Anda',
    step1_subtitle:
      'Apakah nama awak? Anda datang dari mana? Apakah tajuk pekerjaan anda?',
    step2_title:
      'Langkah ke-2: Pilih Beberapa Kemahiran yang Anda Ingin Mahirkan',
    step2_subtitle:
      'Seterusnya, beritahu kami apa yang anda ingin belajar dengan lebih lanjut. Ia mungkin sesuatu yang anda belum belajar lagi? Bidang yang baru?Ataupun sesuatu yang orang kesayangan anda buat? '
  },

  pagebuilder: {
    title: 'Cipta Ajaran',
    subtitle:
      'Masa untuk mencipta kandungan untuk penonton anda supaya mereka dapat belajar dari anda, anda boleh masukkan gambar, video dan infografik ',
    select_layout: 'Pilih Tataletak Halaman',
    template1: 'Kosong',
    template2: 'Tajuk & Sarikata',
    template3: 'Tajuk & Teks',
    template4: 'Tajuk, Media & Teks',
    template5: 'Tajuk & Media',
    template6: 'Tajuk & Kuiz'
  },

  pageconstructor: {
    title: 'Cipta dan Klon Pelajaran',
    subtitle:
      'Masa untuk mencipta kandungan untuk penonton anda supaya mereka dapat belajar dari anda, anda boleh masukkan gambar, video dan infografik '
  },

  passwordreset: {
    success_coded:
      'Kami telah hantar kod pengesahan ke alamat e-mel yang anda berikan, sila salin kod tersebut ke ruang di bawah untuk set semula kata laluan yang baru.',
    success_changed:
      'Anda telah berjaya menetapkan kata laluan yang baru. Anda boleh log masuk sekarang. '
  },

  placeholders: {
    search: 'Cari',
    answer: 'Jawapan',
    chat: 'Tulis Sesuatu...',
    code: 'Kod',
    criterion: 'Kriteria',
    date_event: 'Pilih tarikh & masa',
    date_start: 'Tarikh Permulaan',
    date_expire: 'Tarikh Tamat Tempoh',
    description: 'Penerangan',
    elements: 'Susun elemen',
    email: 'E-mel',
    feedback_correct: 'Maklum Balas Betul',
    feedback_incorrect: 'Maklum Balas Salah',
    host: 'Hos',
    keywords: 'Cari kata kunci(lebih dari 1)',
    lesson_description: 'Penerangan Pelajaran',
    location: 'Lokasi',
    minutes: 'Minit',
    name: 'Nama',
    organiser: 'Pencipta',
    organization: 'Organisasi',
    password: 'Kata Laluan',
    phone: 'Telefon',
    photo: 'Gambar',
    picture: 'Gambar',
    point: 'Titik',
    position: 'Posisi',
    question: 'Soalan',
    quiz: 'Nama Kuiz',
    search_course: 'Cari Mengikut Kursus',
    search_media: 'Cari media',
    search_name: 'Cari mengikut Nama',
    search_title: 'Cari mengikut Tajuk',
    search_training: 'Cari Latihan',
    settings: 'Seting',
    tags: 'Teg',
    title: 'Tajuk',
    topics: 'Topik',
    username: 'Name Pengguna',
    keyword: 'Kata Kunci',
    max_500_characters: 'Maksimum 500 Aksara ',
    no_description: 'Fail ini tidak mempunyai penerangan',
    no_keyword: 'Fail ini tidak mempunyai kata kunci',
    no_topics: 'Fail ini tidak mempunyai set topik',
    feedback: 'Mesej',
    contact: 'Bagaimana kita boleh membantu?'
  },

  publishsettings: {
    title: 'Terbit Seting',
    event_subtitle:
      'Tetapkan seting di acara anda, siapa yang dapat menonton dan berinteraksi dengan acara anda',
    assessment_subtitile:
      'Namakan Penilaian anda dan beritahu penonton anda apa yang mereka jangka akan belajar ',
    course_subtitle:
      'Tetapkan seting di acara anda, siapa yang dapat menonton dan berinteraksi dengan acara anda',
    disclaimer:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam venenatis tellus ex, eu auctor diam tristique et. Fusce vel egestas felis, vel malesuada justo. Suspendisse erat orci, dapibus a nisi quis, ultricies mattis arcu. Proin in suscipit metus. Sed mi tellus, porta in porta eu, accumsan a purus. Donec quis turpis vestibulum, consequat urna ut, vestibulum ex. Sed vulputate ornare auctor. Proin gravida luctus justo at interdum. Proin porttitor, turpis et tincidunt lobortis, dui tortor viverra risus, quis venenatis',
    dates_validation_error: 'Kedua-dua tarikh mesti diisi.',
    course_dates_validation_error: 'Sila masukkan tarikh mula dan tamat tempoh kursus ini.',
    emails_validation_error: 'Senarai e-mel tidak sah.',
    specific_email_validation_error: 'Hanya terima satu e-mel sahaja.',
    i_agree_to_these: 'Saya bersetuju dengan:',
    terms_and_conditions: 'terma dan syarat.',
    PublicDescription:
      'Pengguna bebas: (pilihan peribadi dan terbuka) [Kursus | Acara | Penilaian] anda telah disimpan dan dikelas peribadi secara lalai. Ini bermakna hanya anda yang dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh menukar menjadi status terbuka di bawah. Ini bermaksud bahawa kursus ini akan tersedia untuk semua pengguna di platform. ',
    OrganisationsDescription:
      'Pengguna Organisasi: (Jangan pilih "" Selesai "" pilih "" Terbit "" dan bawa anda ke halaman penerbitan yang sama dengan pengguna lain tanpa pilihan penerbitan.) [Kursus | Acara | Penilaian] anda telah disimpan dan dikelaskan Peribadi. Ini bermakna hanya anda dan Pengendali dalam organisasi anda dapat melihatnya. Sebagai pengguna, anda tidak dapat menerbit kandungan sendiri dalam organisasi anda kerana ini memerlukan kebenaran Pengendali. Sila hubung salah satu Pengendali anda dan minta mereka menerbitkan kandungan anda secara terbuka ke seluruh organisasi, ke kumpulan tertentu dalam organisasi anda atau kepada pengguna tertentu. ',
    OrganisationGroupsDescription:
      'Pengendali Organisasi: (Untuk kandungan yang dicipta dalam organisasi: Peribadi, awam, organisasi, kumpulan, pengguna tertentu): [Kursus | Acara | Penilaian] ini telah disimpan dan dikelaskan Peribadi secara lalai. Ini bermaksud bahawa hanya anda (dan pencipta kandungan) yang dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh pilih salah satu pilihan di bawah. Menerbitkan kursus anda ke status terbuka bermaksud bahawa ia akan tersedia untuk semua pengguna di platform - termasuk mereka yang berada di luar organisasi anda. Menerbitkannya ke organisasi bermaksud semua pengguna dalam organisasi akan dapat melihatnya. Anda juga boleh menerbit lebih dari 1 kumpulan, ini bermaksud hanya pengguna dalam kumpulan tersebut yang dapat melihatnya. Akhirnya, anda mempunyai pilihan untuk menerbitkannya kepada pengguna tertentu di dalam dan di luar organisasi anda menggunakan alamat e-mel yang paut dengan akaun Sharelook mereka. ',
    SpecificUsersDescription:
      'Pengguna berbayar: (pengguna peribadi, awam dan pengguna tertentu) [Kursus | Acara | Penilaian] anda telah disimpan dan dikelaskan Peribadi secara lalai. Ini bermakna hanya anda yang dapat melihat kandungan ini. Untuk menerbitkan kandungan ini, anda boleh pilih salah satu pilihan di bawah. Menerbitkan kursus anda ke status terbuka bermaksud ia akan tersedia untuk semua pengguna di platform. Pilihan Pengguna Tertentu akan membolehkan anda berkongsi kursus anda dengan pengguna tertentu menggunakan alamat e-mel yang paut dengan akaun Sharelook mereka. '
  },

  quiz: {
    quiz_empty: 'Anda masih belum cipta kuiz ',
    questions_empty: 'Anda masih belum cipta soalan '
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Japan',
    asia_pacific_s_korea: 'Korea Selatan',
    asia_pacific_singapore: 'Singapura',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Belgium',
    eu_germany: 'Jerman',
    eu_ireland: 'Ireland',
    south_america_brazil: 'Brazil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Carolina Selatan',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregon'
  },

  reports: {
    title: 'Laporan'
  },

  signup: {
    success_step1:
      'Kami telah hantar kod pengesahan ke alamat e-mel yang anda berikan, sila salinkan kod tersebut ke ruang di bawah untuk mengesahkan pendaftaran anda.',
    success_step2: 'Terima kasih. Anda telah berjaya mendaftar. ',
    privacy: `Saya setuju dengan <1> terma & syarat </1> dan <3> polisi privasi </3>`
  },

  stream: {
    emotion_impressive: 'Mengagumkan',
    emotion_unimpressive: 'Biasa saja',
    message_not_started: 'Akan Datang',
    message_running: 'Siaran Langsung',
    message_processing:
      'Kami sedang proses rakaman siaran langsung. Sila kembali sebentar lagi untuk tonton video dan masukkan penilaian dan maklum balas anda'
  },

  tabs: {
    audience: 'Penonton',
    course: 'Rumusan Kursus',
    details: 'Butiran Acara',
    description: 'Penerangan',
    host: 'Hos',
    lesson: 'Rumusan Pelajaran',
    lessons: 'Ajaran',
    overview: 'Rumusan',
    page: 'Pembina Halaman',
    publish: 'Terbit',
    settings: 'Terbitkan Seting',
    total_views: 'Jumlah tontonan',
    live_participates: 'Peserta Secara Langsung',
    live_chats: 'Kotak Sembang Secara Langsung',
    live_quiz: 'Undian Secara Langsung',
    trainer_rating: 'Penilaian Jurulatih',
    trainer_times: 'Sesi Jurulatih',
    courses_quizzes: 'Kuiz Kursus',
    user_list: 'Senarai Pengguna',
    discussion: 'Perbincangan',
    notes: 'Nota Saya'
  },

  topics: {
    SALES_TRAINING: 'Latihan Jualan',
    NEGOTIATION_TRAINING: 'Latihan Rundingan',
    CROSS_CULTURAL_AWARENESS: 'Pengetahuan Merentas Budaya',
    NETWORKING_SKILLS: 'Kemahiran Membina Perhubungan',
    SOFTWARE_ARCHITECTURE: 'Senibina Perisian',
    PROJECT_MANAGEMENT: 'Pengurusan Projek',
    DIGITAL_TRANSFORMATION: 'Transformasi Digital',
    IT_CONSULTING: 'Konsultan IT',
    MANAGEMENT_CONSULTING: 'Konsultan Pengurusan',
    HR_CONSULTING: 'Konsultan Sumber Daya Manusia',
    INTERNET_OF_THINGS: 'Internet untuk Segalanya (IoT)',
    CYBERSECURITY: 'Sekuriti Siber',
    PRIVACY_AND_GDRP: 'Privasi dan Peraturan Umum Perlindungan Data(GDPR)'
  },

  training: {
    title: 'Latihan',
    title_assessment: 'Penilaian',
    subtitle: 'Kursus dan Acara Langsung',
    enrolled_title: 'Kursus dan Acara Yang Didaftar',
    enrolled_subtitle: 'Kursus dan Acara Yang Anda Sertai',
    enrolled_message: 'Anda belum daftar sebarang kursus dan acara.',
    past_live_event_title: 'Acara Langsung yang lalu',
    past_live_event_subTitle: 'Acara Langsung yang tamat',
    past_live_event: 'Tidak Ada Acara Langsung yang Lalu.',
    recomended_title: 'Kursus dan Acara yang Dicadangkan',
    now_live_event_title: 'Kini Berlangsung',
    now_live_event_subTitle:
      'Acara Langsung yang disiarkan sekarang atau sebentar lagi',
    now_live_event: 'Tidak ada siaran langsung buat masa ini.',
    webinar_event_title: 'Saluran Persidangan Web',
    webinar_event_subTitle: 'Persidangan Web yang telah Tamat',
    webinar_event: 'Tiada Persidangan Web Buat Masa Sekarang.',
    p2p_event_title: 'Sesi Bimbingan',
    p2p_event_subTitle: 'Sesi Bimbingan yang telah Tamat',
    p2p_event: 'Tiada Sesi Bimbingan Buat Masa Sekarang.',

    now_live_assessment_title: 'Kini Berlangsung',
    now_live_assessment_subTitle:
      'Penilaian Langsung yang disiarkan sekarang atau sebentar lagi',
    now_live_assessment_message: 'Tiada Penilaian Langsung Buat Masa Sekarang.',

    upcoming_assessment_title: 'Penilaian Langsung Yang Akan Datang',
    upcoming_assessment_subtitle: 'Penilaian Langsung Yang Akan Datang',
    upcoming_assessment_message:
      'Tiada Penilaian Langsung Akan Datang Buat Masa Sekarang.',

    past_live_assessment_title: 'Penilaian Langsung yang Lalu',
    past_live_assessment_subTitle: 'Penilaian Langsung yang telah Tamat',
    past_live_assessment_message:
      'Tiada Penilaian Langsung yang Lalu Buat Masa Sekarang.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Kami telah menyusun kursus dan acara langsung berdasarkan <0><0/></0> anda',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Cari Latihan',
    search_assessment: 'Cari Penilaian',
    recomended_message:
      'Tidak ada cadangan kursus dan acara buat masa sekarang.'
  },

  warnings: {
    delete: 'Adakah anda pasti?'
  },

  workshop: {
    title: 'Bengkel Saya',
    subtitle: 'Cipta kursus atau acara langsung anda',
    new_course: 'Cipta Kursus Baru',
    new_event: 'Cipta Acara Langsung Baru',
    new_assessment: 'Cipta Penilaian Langsung Baru',
    courses_title: 'Kursus dan Acara Langsung Yang Telah Dicipta',
    courses_subtitle: 'Edit & Terbitkan kursus anda dan reka acara anda',
    tags_course: 'Kursus',
    tags_live: 'Acara Langsung',
    tags_assessment: 'Penilaian Langsung'
  },

  help_center: {
    sidebar: {
      title: 'Bagaimana Kami Boleh Bantu Anda?',
      back_to: 'Papan Pemuka'
    },
    menu: {
      help_center: 'Pusat Bantuan',
      whats_new: 'Apa Yang Baru',
      feedback: 'Maklum Balas',
      feedback_title: 'Hantar maklum balas ke sharelook',
      terms_and_conditions: 'Terma & Syarat',
      privacy_policy: 'Polisi Privasi',
      contact_us: 'Hubungi Kami'
    },
    get_started: {
      title: 'Bermula dengan share look',
      description: {
        main:
          'KAMI TELAH MENGGABUNGKAN VIDEO LANGSUNG KE DALAM PEMBINA KURSUS YANG MUDAH DIGUNA',
        tagline:
          'Dengan sistem siaran langsung yang hakcipta dari ShareLook, anda dapat mendorong pembabitan, membenarkan pelajaran secara automatik dan meningkatkan perkongsian pengetahuan .'
      }
    },
    whats_new: {
      title: 'Bermula dengan share look',
      description: {
        main:
          'Adakah anda tahu bahawa dengan menggunakan cara pembelajaran bercerita, anda boleh cipta kursus dalam masa yang pendek dengan harga yang berpatutan?  Anda patut gabungkan pembina kursus ShareLook dengan bakat anda. Kami boleh ajar anda "Bagaimana',
        tagline: ''
      }
    },
    create_workshop: 'Cara Membina Bengkel',
    create_course: 'Cara Mencipta Kursus',
    create_user: 'Cara Mencipta Pengguna',
    create_group: 'Cara Mencipta Kumpulan',
    create_webinar: 'Cara Membuat Persidangan Web',
    create_live_event: 'Bagaimana Membuat Acara Langsung',
    create_live_assessment: 'Cara Membuat Penilaian Langsung',
    create_live_on_mobile: 'Bagaimana Membuat Siaran Langsung Dari Telefon',
    personalize_profile: 'Bagaimana Membina Profil Anda',
    manage_group: 'Mengurus Kumpulan',
    report: 'Laporan',
    add_annotations: 'Bagaimana Tambah Anotasi / Menu Timbul',
    add_audio: 'Cara Masukkan Audio',
    add_header_and_footer: 'Cara Masukkan Pengepala dan Pengaki',
    add_image: 'Cara Masukkan Imej',
    add_quiz_content: 'Cara Masukkan Kandungan Kuiz',
    add_text_content: 'Cara Masukkan Kandungan Teks',
    add_user: 'Cara Menambah Pengguna',
    add_video: 'Cara Masukkan Video',
    clone_course: 'Cara Klon Kursus',
    find_live_broadcast: 'Bagaimana Cari Saluran Siaran Langsung',
    contact_us: {
      title: 'Hubungi Kami',
      subject_placeholder: 'Masukkan subjek*',
      content_placeholder: 'Isikan mesej*',
      subject_required: '*Subjek diperlukan',
      content_required: '*Mesej diperlukan',
      submit: 'Hantar',
      cancel: 'Batal',
      sent: 'Sudah Hantar'
    },
    feedback: {
      title: 'Hantar Maklum Balas ke sharelook',
      attach_title: 'Lampiran fail',
      choose: 'Pilih Fail',
      detail: 'Fail akan dikongsi dengan pasukan sokongan',
      content_placeholder: 'Masukkan Mesej*',
      content_required: '*Mesej Diperlukan',
      submit: 'Hantar',
      cancel: 'Batal',
      sent: 'Sudah Hantar'
    }
  },
  discussion: {
    join_discussion: 'Sertai dalam perbincangan'
  },
  notes: {
    title: 'Nota Saya',
    add_note: 'Tambah Nota Baru'
  }
}
